import * as React from 'react';

import ROUTES from 'platform/constants/routes';
import Settings from 'platform/services/settings';

const cardInfo = <>
  <p>Հարգելի հաճախորդներ, Ալֆա Ֆարմ դեղատների ցանցը 01.11.2016թ․-ից գործարկում է հաճախորդների խրախուսման նոր բոնուսային ծրագիր, որը հնարավորություն է ընձեռում հաճախորդներին կատարելով գնումներ Ալֆա Ֆարմ դեղատներից, դրանց դիմաց կուտակել միավորներ և ծախսել ցանկացած ժամանակ: Միավորները կուտակվում են կախված կատարված գնումների գումարի չափից, ինչպես նաև քարտապանները հնարավորություն կունենան կուտակել ԲԱՐՁՐ միավորներ՝ կատարելով գնումներ կիրակի օրերին, ընտրելով իրենց կողմից հաճախակի գնվող 2 ապրանքատեսակ կամ գնելով նշված ապրանքանիշերի տեսականուց։</p>
  <h4>«ԱլֆաՔարտ» Բոնուսային ծրագիր</h4>
  <p>Ներկայացրեք «ԱլֆաՔարտ»-ը և կուտակեք միավորներ ըստ հետևյալ սանդղակի.</p>


  <ul>
    <li>2 միավոր  յուրաքանչյուր 100 դրամի դիմաց` մինչև 10 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>3 միավոր յուրաքանչյուր 100 դրամի դիմաց` 10 000-ից մինչև 20 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>5 միավոր  յուրաքանչյուր 100 դրամի դիմաց` 20 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
    <li>+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` 40 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
    <li>+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց՝  կիրակի օրերին գնումներ կատարելիս</li>
  </ul>

  <p>Նաև հնարավորություն ունեք կուտակել բարձր միավորներ`</p>

  <ul>
    <li>ընտրեք կամայական երկու Հատուկ ապրանքատեսակ և կուտակեք ավելի շատ՝  յուրաքանչյուր 100 դրամի դիմաց, կախված ապրանքատեսակից: Ապրանքները կարող են փոփոխվել ամեն 3 ամիսը մեկ:</li>
    <li>կուտակեք հատուկ բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` հետևյալ ապրանքանիշերի ապրանքատեսակները գնելիս. Avene,Vichy, La Roche-Posay, Ducray, Bambo, Mustela, Bebble, Maternea, Derma, Canpol, Abena, Lavena, Abri, Bioderma, Swiss image, Swiss code, Vetia floris, Himalaya:</li>
  </ul>

  <p>Վերոնշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։</p>

  <p>Ցածր միավորներ կարող են տրամադրվել կամ ընդհանրապես չտրամադրվել ընկերության կողմից   որոշ փոքրաքանակ ապրանքախմբերի համար, որոնք վաճառվում են ցածր գներով կամ Հատուկ զեղչով:</p>
  <p>Առանձին ակցիաների դեպքում դրանց կուտակման պայմանները սահմանվում են առանձին-առանձին։</p>
  <p>Կուտակված միավորներն օգտագործելիս դրանց դիմաց նոր միավորներ չեն կուտակվում։ </p>
  <p>Մեկ տարուց ավել քարտը չօգտագործելու դեպքում այն ավտոմատ կարգելափակվի և միավորները կզրոյացվեն:</p>

  <h4>«Ալֆա Քարտ» - «Բոնուսային» ծրագիր կորպորատիվ հաճախորդների համար</h4>
  <p>«Ալֆա Քարտ» կորպորատիվ հաճախորդների բոնուսային կուտակային ծրագիրը հնարավորություն է ընձեռում հաճախորդներին կատարել գնումներ «Ալֆա-Ֆարմ» դեղատներից, դրանց դիմաց կուտակել միավորներ և ծախսել ցանկացած ժամանակ` մաս-մաս կամ ամբողջությամբ (1 միավորի արժեքը 1 դրամ է): Միավորները կուտակվում են կախված հաճախորդի միանվագ կատարված գնումների գումարի չափից` ըստ հետևյալ սանդղակի.</p>

  <ul>
    <li>6 միավոր  յուրաքանչյուր 100 դրամի դիմաց` մինչև 10 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>7 միավոր յուրաքանչյուր 100 դրամի դիմաց` 10 000-ից մինչև 20 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>9 միավոր  յուրաքանչյուր 100 դրամի դիմաց` 20 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
    <li>+1 լիացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` 40 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
  </ul>

  <p>Քարտապանը հնարավորություն ունի նաև հիմնական սանդղակից զատ կուտակել լրացուցիչ բարձր միավորներ`</p>

  <ul>
    <li>«Հատուկ» բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` յուրաքանչյուր քարտապան ունի հնարավորություն նշել 2 «Հատուկ ապրանքատեսակ», որը նա կարող է գնել և ստանալ լրացուցիչ միավորներ: Ապրանքները կարող են փոփոխվել ամեն 3 ամիսը մեկ: Նշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։</li>
    <li>«Հատուկ» բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` յուրաքանչյուր քարտապան ունի հնարավորություն կուտակել բարձր միավորներ հետևյալ ապրանքանիշերի ապրանքատեսակները գնելիս` Avene, Vichy, La-Roche-Posay, Ducray, Bambo, Mustela, Bebble, Maternea, Derma, Canpol, Abena, Lavena, Abri, Bioderma, Swiss image, Himalaya:  Նշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։</li>
    <li>+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` յուրաքանչյուր քարտապան կունենա հնարավորություն կուտակել բարձր միավորներ կատարելով գնումներ ամսվա կիրակի օրերին:</li>
  </ul>

  <p>*1 տարուց ավել քարտը չօգտագործելու դեպքում, այն ավտոմատ կարգելափակվի:</p>
  <p>*Ցածր միավորներ կարող են տրամադրվել կամ ընդհանրապես չտրամադրվել ընկերության կողմից սահմանված որոշ փոքրաքանակ ապրանքախմբերի համար, որոնք վաճառվում են ցածր գներով կամ «Հատուկ զեղչով»-ով:</p>
  <p>* Առանձին ակցիաների դեպքում դրանց կուտակման պայմանները սահմանվում են առանձին-առանձին։</p>
  <p>*Կուտակված միավորներն օգտագործելիս դրանց դիմաց նոր միավորներ չեն կուտակվում։ </p>
  <p>Մեկ տարուց ավել քարտը չօգտագործելու դեպքում այն ավտոմատ կարգելափակվի և միավորները կզրոյացվեն:</p>
</>;

const contactText = <>
  Уважаемые клиенты, <br /> <br />
  Мы благодарим Вас за интерес к нашим  услугам. <br />
  Мы работаем, чтобы улучшить качество  наших услуг, поэтому мы придаем большое значение обратной связи с нашими клиентами. <br />
  В случае возникновения вопросов или проблем, просим заполнить строки ниже или  звонить по телефону <br />
  <b>011 200 900</b> <br /> <br />
  <address>
    ООО КРОМА ГРУМ <br />
    0060, РА, г. Ереван, Аван 4/14 <br />
    ИНН 00888954 <br />
    ЗАО АМЕРИАБАНК <br />
    Гр.Лусаворич ул 9 <br />
    Б/с 1570020377270100
  </address>
</>;

const contractText = <>
  1. Данный договор (отныне контракт) определяет и регулирует правопорядок оказываемых услуг со стороны ООО “Крома Груп” (отныне также компания) на сайте Ineed.am (отныне также сайт).<br /><br />
  2. Заходя на сайт, пользуясь любой услугой или вводя любое содержание, целиком или частично ,вы, как пользователь (впредь также пользователь, Вы, Ваш, Вас, Клиент), подтверждаете, что полностью прочитали и поняли контракт, а также другие условия оказания услуг (впредь также “Условия или контракт”) со стороны компании на сайте, и принимаете их, независимо от того вы являетесь клиентом оказываемых услуг этой компании, пользователем сайта или просто посетителем.<br /><br />
  3. Компания имеет право без предварительного уведомления, в одностороннем порядке, в любое время изменить контракт. В этом случае измененный  контракт будет помещен на сайте, с указанием даты последних изменений. При посещении сайта, в обязанности пользователя входит  ознакомление с изменениями в контракте (при наличии таковых). Изменения входят в силу со дня размещения их на сайте, и распространяются на возникшие после этого отношения.<br /><br />
  4. Если вы не согласны с контрактом, необходимо прекратить пользование сайтом .Нахождение на сайте, открытие счета, становление пользователем означает ваше безоговорочное принятие условий контракта и его заключение.<br /><br />
  5. Заключая договор вы подтверждаете, что полностью дееспособны и имеете право пользоваться услугами. Если вы представляете юридическое лицо, то вы свидетельствуете, что вы правомочны пользоваться услугами от имени юридического лица. Тем самым вы принимаете, что компания не может проверить правдивость данных вами сведений в этом пункте, следовательно, ответственность за любое нарушение данного пункта полностью падает на вас.<br /><br />
  6. Для пользования полным объемом оказываемых компанией услуг, вы должны зарегистрироваться на сайте и создать личную страницу(впредь личная страница пользователя или личная страница). Каждый пользователь может иметь одну личную страницу. Один пользователь не имеет права пользоваться личной страницей другого пользователя. При открытии личной страницы пользователь обязан правдиво представить всю требуемую информацию. Пользователи сами ответственны за сохранение данных входа на свою личную страницу и сами несут ответственность за действия на личной странице. В случае, если произошел неразрешенный вход на личную страницу пользователя, он обязан незамедлительно проинформировать компанию. В подобном случае компания имеет право закрыть личную страницу до полного выяснения обстоятельств. В любом случае компания не несет никакой ответственности за действия, совершенные другими лицами на личной странице пользователя. Ответственность за причинение ущерба компании или другим лицам своей деятельностью несет пользователь.<br /><br />
  7. Предоставленные компанией услуги включают, но не ограничиваются следующим;<br />
  <ul>
    <li>Организация транспортировки  купленных при помощи  компании товаров клиентам.</li>
    <li>Организация транспортировки товаров ,купленных клиентами самостоятельно.</li>
    <li>Складирование товаров  покупателей.</li>
  </ul>
  8. Компания имеет право отказать в оказании услуг любому физическому или юридическому лицу, на свое усмотрение в случае отсутствия возможности их выполнения.<br /><br />
  9. Компания, в период, когда увеличивается общий объем заказов(праздники, скидочные программы или мероприятия) имеет право отсрочить доставки, а также приостановить предоставление определенных услуг.<br /><br />
  10. Заказ доставляется по адресу, указанному на сопутствующем документе и вручается заказчику или его полномочному представителю с подписью. Получатель подтверждает получение и на сопутствующем документе указывает;<br />
  <ul>
    <li>имя и фамилию</li>
    <li>подпись</li>
    <li>дату и время доставки заказа</li>
    <li>письменное указание о полноценности и целостности заказа.</li>
  </ul>
  11. При невозможности сдачи заказа получателю (законному представителю) товар хранится в течение  30 дней на складе компании. Отправитель или получатель с помощью договора может продлить срок хранения заказа. В случае если  в течение 30 дней заказ не принимается, а соответствующий договор о продлении хранения отсутствует, компания имеет право отклонить заказ, удержать расходы из полученной суммы, по цене, удобной ей, а остальную сумму вернуть клиенту или сдать в депозит нотариусу или адвокату.<br /><br />
  12. Заказ сдается при наличии документа,удостоверяющего личность,водительского права или военного билета.<br /><br />
  13. При невыполнении услуг,либо выполнении недолжным образом,клиент имеет право предъявить компании или партнерской организации письменную претензию.<br /><br />
  14. В письменной претензии отмечаются;<br />
  <ul>
    <li>Данные документов, подтверждающих личность заявителя(законного представителя)</li>
    <li>Суть требования</li>
  </ul>
  15. Компания изучает письменные требования и жалобы и отвечает в срок,утвержденный законодательством.<br /><br />
  16. Компания не несет ответственности за предлагаемые ,оказанные услуги,товары и работы со стороны третьих лиц на сайте.
</>;

const exchangeReturnText = <>
  <b>Обмен и возврат товара с надлежащим качеством</b><br /><br />
  Купленный товар можно вернуть или  заменить  на товар другого размера, формы, цвета или подобной комплектации, производя необходимый перерасчет в случае разницы в цене, в течение 14 дней со дня вручения товара покупателю, кроме нижеуказанных случаев и товаров, по порядку, установленному правительством.
  Непродовольственный товар с надлежащим качеством заменяется или возвращается, если данный товар не использовался , сохранил товарный вид, потребительское качество, пломбы, бирки, подтверждающие оплату документы, как доказательство того, что покупка осуществлена у данного продавца.<br /><br />
  <b>Товар с надлежащим качеством не может быть возвращен:</b><br /><br />
  а) если изготовление товара и его снабжение осуществлены по особому заказу потребителя, либо товары персонифицированы.<br />
  б) когда продаются быстропортящиеся товары, разрушающиеся,  либо меняющие качество.<br />
  в) в случае продажи товаров, которые после поставки, исходя из своей природы, неразрывно сливаются друг с другом.<br />
  д) в случае пломбированных  аудио или видео записей или пломбированных программ со стороны покупателя.<br />
  е) в случае поставок газет, журналов, книг или других печатных изданий<br />
  ж) при соглашениях, подписанных на аукционах и биржах<br />
  з) при цифровых поставках, не соответствующих  цифровому носителю, когда осуществление этого произошло на основе предварительного соглашения с покупателем, по которому он теряет свое право возврата.<br /><br />
  <b>Возврат или обмен товара с ненадлежащим качеством.</b><br /><br />
  При получении товара с ненадлежащим качеством, продавец имеет право провести экспертизу качества товара, результаты, которые будут представлены вам. В технически сложных случаях, требование покупателя о возврате или обмене на подобный образец, или другой товар, может быть удовлетворено при обнаружении  в товаре существенных нарушений.
  При приобретении покупателем товара с ненадлежащим качеством, продавец обязан заменить данный товар на товар с надлежащим качеством либо вернуть покупателю заплаченную сумму, если недостатки товара обнаружены в течение срока годности.
  Обмен или возврат товара регулируется законодательством Республики Армения «О защите прав потребителя».
</>;

const confidentialityConditionsText = <>
  Данная политика распространяется на всех тех посетителей, пользователей и других лиц, которые пользуются услугами сайта Ineed.am (далее сайт), либо имеют право пользоваться подобными услугами. Намереваемся проинформировать, какие данные собираются, обрабатываются и как они используются для регистрации на сайте. Данная политика в любое время, без предварирельного осведомления может быть изменена  односторонне. Измененный вариант будет оглашен на сайте, с указанием последней даты поправки .Новые условия получат юридическую силу с момента помещения на сайте и распространятся на возникшие после этого обязательства. Обязанностью посетителей сайта является ознакомление с его изменениями и посещение сайта время от времени.<br /><br />
  1. Посещая сайт, вы даете свое согласие на использование и обработку личных данных, внесенных вами на сайт. Согласно данной политике , в обратном случае вы не имеете права пользоваться оказанными на сайте услугами.<br /><br />
  2. Недееспособные, либо лица, не достигшие 18 лет(исключая случаи полного признания дееспособности в законодательном порядке), не имеют права пользоваться оказанными на сайте услугами. При отсутстствии возможности проверки подлинности вводимых пользователем данных, мы не несем ответственности за последствия при пользовании нашими услугами, и, при любом нарушении данного пункта, ответственность полностью лежит на вас.<br /><br />
  3. Личные данные и другая информация. Вы можете посетить наш сайт без регистрации, однако для полного пользования услугами сайта, вы обязаны зарегистрироваться на сайте. Личные данные собираются только тогда, когда вы их предоставляете. Для регистрации вы должны написать ваше имя, адрес, адрес электронной почты и контактные данные. Во время посещения сайта собирается также некоторая информация о вашем компьютере; IP адрес, наименование браузера, вид компьютера, технические данные пользования, а также средства установления связи с нашим сайтом, такие, как, вид операционной системы, наименование представляющей интернет услуги организации, а также другие подобные данные. Собираемая информация дает возможность вычислить количество посетителей, создать статистику о посещении страниц .Сайт использует cookies.Это цифробуквенные строки, которые создаются при посещении сайта и копируются  в вашем компьютере. Они не собирают личную информацию. С их помощью пользование сайтом становится намного проще и удобнее.<br /><br />
  4. Способы использования предоставленной вами информации;<br />
  <ul>
    <li>Для предложения заинтересовавших вас товаров и услуг</li>
    <li>Для осуществления  услуг</li>
    <li>Содействие вам, в случае возникновения технических сложностей на сайте</li>
    <li>Для сообщения вам новостей, новых товаров или услуг, а также особых предложений.</li>
    <li>Для улучшения сайта, услуг и товаров.</li>
  </ul>
  5. Защита личных данных<br /><br />
  Мы осуществляем необходимые мероприятия  для обеспечения безопасности ваших личных данных. Предоставленная вами информация хранится в базе надежных серверов. Ваши личные данные будут предоставлены сотрудничающим на сайте организациям ,если это необходимо для осуществления оказываемых вам услуг и улучшения их качества(например; получение заказов и складирование ,доставка, отправка почтовых и электронных писем, анализирование базовых данных ,оказание маркетинговых услуг, осуществление оплат банковыми картами, обслуживание посетителей, и т.д.)Эти лица получают доступ к информации с целью осуществления указанных операций и не имеют права использовать эти данные в других целях.
  6. Действующее законодательство.<br /><br />
  Заходя на сайт или пользуясь им, вы принимаете, что все вопросы, связанные с посещением и пользованием сайта, регулируются законодательством Республики Армения. При возникновении споров, они регулируются с помощью переговоров, при разногласиях споры будут разрешены в порядке, установленном законодательством Республики Армения.
</>;

const aboutTheProjectText = "Команда Ineed приветствует вас. Ineed электронная страница, где можете приобрести любой товар с оптимальней ценой без долгих поисков. Входите в Ineed, заполните свой заказ, и отправляйте. В течение одного рабочего дня наши специалисты анализируют рынок, и предсттавлют вас ценовое предложение, из которого можете выбрать идеальный вариант для Вас, и мы доставлем по адресу указенном Вами. А также Ineed предоставляет Вам возможность найти Ваших поставщиков, продать товары быстро и без лишных затрат, отдать на хранение товары, и транспортировать по указанному адресу.";

const howWeWorkText = <>
  <h3>Заполните данные о любом товаре и отправьте нам</h3>
  <p>В любой письменной форме заполните название необходимого вам товара, единицу измерения, количество(от чего может зависеть предлагаемая цена), техническая или другая характеристика, и, нажимая клавишу “ отправить” осуществите заказ. При необходимости можете прикрепить фотографию, файлы, технические чертежи и другие документы. Если у вас есть готовый список товаров, которые вы намереваетесь заказать, то можете список приложить в соответствующем месте, чтобы выиграть время. При заказах в большом количестве ценовое предложение  и импортировка  товара непосредственно от производителя.</p>

  <h3>Мы вычислим стоимость заказа в течение 24 часов</h3>
  <p>После получения заказа, для нахождения более продуктивного варианта, наши специалисты изучат оптовый рынок, и в течение 24 часов по обратному адресу отправят предложение, которое вы можете принять полностью либо частично. Покупки можно произвести: наличными, оплачивая непосредственно курьеру, онлайн, по одному из указанных на сайте способов. При покупке товара возможно его складирование(хранение) и доставка. Мы гарантируем конкурентоспособность предложенных нами цен, учитывая приобретенные эксклюзивные договоры, как с местными производителями, так и с оптовиками. При заказе в больших количествах возможно также изучение иностранных рынков и импорт товара. При ввозе товаров команда Ineed осуществит покупку, импорт, растаможивание, складирование и доставку товара.</p>

  <h3>Управляйте вашими покупками при помощи личной страницы</h3>
  <p>На сайте личная страница – это персональная территория, где вы можете получить достоверные сведения об осуществляемых действиях. Для входа достаточно зарегистрироваться или записаться, после чего вы можете получить цельную информацию о вашей деятельности на сайте. Вы получаете большие привилегии, так как видите  всю информацию о вашей деятельности, а также имеете возможность быстрого получения помощи и услуг  команды Ineed обратной связью. Одним словом, вы на своей личной странице можете произвести платежи, а также проанализировать статистику заказов и покупок, произведенных ранее. Архив покупок вам позволит быстро  и без труда повторить ту или иную процедуру. Одной из основных привилегий является то, что при помощи личной страницы можете сразу сделать необходимые поправки, не заходя в наш офис.</p>

  <h3>Мы надежно сохраним ваш товар</h3>
  <p>Если имеете товар, однако в данный момент не используете его, мы предлагаем его полное или частичное хранение в объемных складских помещениях. Под хранением мы понимаем ответственность за надежность и количество вашего товара. При складировании производим максимально оперативный прием заказа, конкретный подсчет товара, а также даем возможность проследить за условиями хранения. Гарантируем надежность товаров, благодаря действующим 24 часа камерам видеонаблюдения. Даем возможность снятия товара в любое время, заполняя заявку в соответствующем разделе, после чего  мы осуществим доставку товара по указанному адресу в короткий срок.</p>

  <h3>Предлагаем быструю и надежную доставку товаров</h3>
  <p>Приобретенный вами, а также сданный на хранение товар можете получить непосредственно со склада, или воспользоваться службой доставки Ineed.Доставка может быть осуществлена со склада Ineed до вашего адреса, выставочного зала или склада, а также в обратном направлении в течении одного рабочего дня. Нашими клиентами могут стать все пользователи сайта Ineed, как физические лица, так и юридические; большие, маленькие, средние организации. Мы предлагаем оптимальную тарифную систему доставки, по которой, при сумме, превышающей нижеуказанную, доставка осуществляется бесплатно, в других случаях расчет осуществляется по прейскуранту. Доставка осуществится в указанные вами заранее сроки, быстро, надежно, машинами, специально предусмотренными для перевозок. Мы гарантируем надежность и безопасность перевозок. При несоответствии вашим ожиданиям, гарантируем возврат товара, а также заплаченной суммы в течение 5 рабочих дней.</p>
</>;

const adventagesText = <>
  <h3>Экономим ваше время, деньги и нервы</h3>
  <p>Очень удобно, просто и быстро пользование услугами ineed. С нашей  помощью можете поднять уровень ваших покупок. Для любого человека самое главное в покупках –это время, деньги и нервы. Никто не хочет тратить их впустую. Целью ineed является осуществление детального изучения рынка и предоставление исчерпывающей информации вам перед предложением цен, и на основе этого вы можете принять оптимальное решение, выбрав удобный вам вариант.</p>

  <h3>Бесплатно предоставлем вам анализ рыночных цен</h3>
  <p>Для продуктивного осуществления покупок важно снижение расходов, что в свою очередь предполагает приобретение товаров по минимальной цене. Ineed предлагает бесплатное предоставление анализа рыночных цен, что позволяет следить за динамикой изменений на рынке, предоставляя клиентам возможность приобретения  необходимого им товара по минимальной цене. Имея анализ рыночных цен вы приобретаете  информационное преимущество  и большую возможность снижения расходов. Предоставляем возможность пользоваться  предложениями наилучших поставщиков, а также договорами с особыми условиями. Приобретенные  нами специальные условия с производителями и оптовиками, позволяют нам предложить  клиентам широкий ассортимент необходимых товаров по наименьшей цене .Благодаря выработанной скидочной системе, можете быть уверены, что снижаете ваши расходы, покупая товар по минимальной цене. Низкие цены формируются на основе специальных и эксклюзивных соглашений с поставщиками, а также благодаря организованной эффективной работе и логистики с нашей стороны.</p>

  <h3>Даем возможность воспользоваться лучшими предложениями поставщиков и контрактами имеющих специальные условия</h3>
  <br /><br />

  <h3>Помогаем компаниям в увеличении объемов и в вовлечении в новые рынки</h3>
  <p>Каждое предприятие ставит цель перед собой увеличить объемы продаж, а также привлечь новые рынки. Войдя в предложенную нами оптовую сеть продаж, вы имеете возможность представить ваш товар во всех розничных и оптовых точках Армении, как под  собственным именем, так и в качестве предложенной нашими сотрудниками товарной марки. Обеспечиваем продвижение товарной марки,осуществляя рекламу, основанную на эффективных и подсчитанных цифрах.</p>

  <h3>Безопасно раскладываем доверенный товар</h3>
  <br /><br />

  <h3>Доставку товара осуществляем быстро и надежно</h3>
  <p>Доставку осуществляем специализированными грузовыми машинами в любое место и в обратном направлении, в течение периода от 08.30 до18.00. Предлагаем 4 вида перевозок; ”Дверь-дверь; Дверь-склад; Склад-дверь; Склад-склад”. БПредлагаем 2 пакета услуг доставки “Стандартная» (доставка осуществляется в течение 1-2 дней, в зависимости от расстояния), и “Быстрая”(доставка осуществляется в течение 1-2 часов, в зависимости от расстояния). Гарантируем доставку товара в сохранности и обеспечиваем гибкую ценовую политику.</p>
</>;

const deliveryText = <>
  <h3>Доставка</h3>
  <p>Мы предлагаем нашим клиентам современный сервис и обслуживание. Мы осуществляем прием продукции и доставку, погрузку и разгрузку, упаковку. Мы также предлагаем доставку с оптимальной тарифной системой, в рамках которой закупки превышающие сумму, установленную ниже будут доставлены бесплатно, в противном случае будет рассчитываться в соответствии с прайс-листом. Продукт будет поставляться в сроки, указанные Вами заранее, быстро и надежно, специальнымы машинамы. Мы гарантируем безопасность продукта и безопасной транспортировки. Если продукт не соответствует вашим  ожиданиям, мы гарантируем возврат продукта, а также возврат уплаченной суммы в течение пяти рабочих дней.</p>

  <h3>Шкала бесплатной доставки</h3><br />
  <table className="G-simple-table">
    <tr>
      <td><strong>Адрес  доставки</strong></td>
      <td><strong>Стоимость покупки (драм)</strong></td>
    </tr>
    <tr>
      <td>г.Ереван</td>
      <td>15,000</td>
    </tr>
    <tr>
      <td>области&lt;50km</td>
      <td>250,000</td>
    </tr>
    <tr>
      <td>области&lt;100km</td>
      <td>400,000</td>
    </tr>
    <tr>
      <td>области&lt;200km</td>
      <td>800,000</td>
    </tr>
    <tr>
      <td>области&lt;300km</td>
      <td>1,200,000</td>
    </tr>
  </table><br /> <br />

  <table className="G-simple-table-mobile">
    <tr>
      <td><strong>Адрес  доставки</strong></td>
      <td><strong>Стоимость покупки (драм)</strong></td>
    </tr>
    <tr>
      <td>г.Ереван</td>
      <td>15,000</td>
    </tr>
    <tr>
      <td>области&lt;50km</td>
      <td>250,000</td>
    </tr>
    <tr>
      <td>области&lt;100km</td>
      <td>400,000</td>
    </tr>
    <tr>
      <td>области&lt;200km</td>
      <td>800,000</td>
    </tr>
    <tr>
      <td>области&lt;300km</td>
      <td>1,200,000</td>
    </tr>
  </table><br /> <br />


  <h3>Установленный прейслист доставок</h3><br />
  <table className="G-simple-table-mobile">
    <tr>
      <td><strong>Город/ село</strong></td>
      <td><strong>Стоимость доставки /драм/</strong></td>
    </tr>
    <tr>
      <td>г.Ереван</td>
      <td>500</td>
    </tr>
    <tr>
      <td>Арарат</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Птгни</td>
      <td>800</td>
    </tr>
    <tr>
      <td>Меградзор</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Нубарашен</td>
      <td>1000</td>
    </tr>
    <tr>
      <td>Талин</td>
      <td>5700</td>
    </tr>
    <tr>
      <td>Прошян/село</td>
      <td>1000</td>
    </tr>
    <tr>
      <td>Анкаван</td>
      <td>6300</td>
    </tr>
    <tr>
      <td>Абовян</td>
      <td>1100</td>
    </tr>
    <tr>
      <td>Джрашен</td>
      <td>6800</td>
    </tr>
    <tr>
      <td>Звартноц</td>
      <td>1100</td>
    </tr>
    <tr>
      <td>Гавар</td>
      <td>7600</td>
    </tr>
    <tr>
      <td>Дзорахпюр</td>
      <td>1100</td>
    </tr>
    <tr>
      <td>Дилиджан</td>
      <td>7700</td>
    </tr>
    <tr>
      <td>Арамус</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Спитак</td>
      <td>7900</td>
    </tr>
    <tr>
      <td>Арзни</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Артик</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Егвард</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Маралик</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Ечмиадзин</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Арени</td>
      <td>8700</td>
    </tr>
    <tr>
      <td>Масис</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Нор Ачн</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Ширакаван</td>
      <td>9100</td>
    </tr>
    <tr>
      <td>Бюрегаван</td>
      <td>1500</td>
    </tr>
    <tr>
      <td>Егегнадзор</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Катнахпюр, Котайк</td>
      <td>1500</td>
    </tr>
    <tr>
      <td>Хндзореск</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Аштарак</td>
      <td>1600</td>
    </tr>
    <tr>
      <td>Чамбарак</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Нор Геги</td>
      <td>1600</td>
    </tr>
    <tr>
      <td>Ванадзор</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Мугни, Аштарак</td>
      <td>1700</td>
    </tr>
    <tr>
      <td>Ахурян</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Лусакерт</td>
      <td>1800</td>
    </tr>
    <tr>
      <td>Гюмри</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Гарни</td>
      <td>2000</td>
    </tr>
    <tr>
      <td>Мартуни</td>
      <td>10100</td>
    </tr>
    <tr>
      <td>Ошакан</td>
      <td>2000</td>
    </tr>
    <tr>
      <td>Вайк</td>
      <td>10900</td>
    </tr>
    <tr>
      <td>Азатаван</td>
      <td>2100</td>
    </tr>
    <tr>
      <td>Иджеван</td>
      <td>11200</td>
    </tr>
    <tr>
      <td>Арташат</td>
      <td>2100</td>
    </tr>
    <tr>
      <td>Амасиа</td>
      <td>11600</td>
    </tr>
    <tr>
      <td>Парпи, Арагацотн</td>
      <td>2100</td>
    </tr>
    <tr>
      <td>Мегрут</td>
      <td>11700</td>
    </tr>
    <tr>
      <td>Гегард</td>
      <td>2300</td>
    </tr>
    <tr>
      <td>Степанаван</td>
      <td>12300</td>
    </tr>
    <tr>
      <td>Чаренцаван</td>
      <td>2600</td>
    </tr>
    <tr>
      <td>Ашоцк</td>
      <td>13000</td>
    </tr>
    <tr>
      <td>Бюракан</td>
      <td>2700</td>
    </tr>
    <tr>
      <td>Варденис</td>
      <td>13200</td>
    </tr>
    <tr>
      <td>Уджан</td>
      <td>2700</td>
    </tr>
    <tr>
      <td>Ташир</td>
      <td>13700</td>
    </tr>
    <tr>
      <td>Мецамор</td>
      <td>2800</td>
    </tr>
    <tr>
      <td>Джермук</td>
      <td>14000</td>
    </tr>
    <tr>
      <td>Арзакан</td>
      <td>3100</td>
    </tr>
    <tr>
      <td>Алаверди</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Кош&nbsp;&nbsp;&nbsp; </td>
      <td>3200</td>
    </tr>
    <tr>
      <td>Ноемберян</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Бжни</td>
      <td>3300</td>
    </tr>
    <tr>
      <td>Берд</td>
      <td>16700</td>
    </tr>
    <tr>
      <td>Арагац</td>
      <td>3400</td>
    </tr>
    <tr>
      <td>Сисиан</td>
      <td>17100</td>
    </tr>
    <tr>
      <td>Аралез</td>
      <td>3400</td>
    </tr>
    <tr>
      <td>Горис</td>
      <td>19700</td>
    </tr>
    <tr>
      <td>Армавир</td>
      <td>3600</td>
    </tr>
    <tr>
      <td>Карвачар</td>
      <td>20000</td>
    </tr>
    <tr>
      <td>Агверан </td>
      <td>3700</td>
    </tr>
    <tr>
      <td>Шуши</td>
      <td>24500</td>
    </tr>
    <tr>
      <td>Раздан</td>
      <td>3700</td>
    </tr>
    <tr>
      <td>Капан</td>
      <td>25300</td>
    </tr>
    <tr>
      <td>Веди</td>
      <td>3700</td>
    </tr>
    <tr>
      <td>Каджаран</td>
      <td>25900</td>
    </tr>
    <tr>
      <td>Авшар</td>
      <td>3900</td>
    </tr>
    <tr>
      <td>Степанакерт</td>
      <td>26100</td>
    </tr>
    <tr>
      <td>Апаран</td>
      <td>4500</td>
    </tr>
    <tr>
      <td>Аскеран</td>
      <td>29300</td>
    </tr>
    <tr>
      <td>Цахкадзор</td>
      <td>4900</td>
    </tr>
    <tr>
      <td>Мартуни</td>
      <td>30500</td>
    </tr>
    <tr>
      <td>Катнахпюр, Арагацотн</td>
      <td>4900</td>
    </tr>
    <tr>
      <td>Мегри</td>
      <td>31300</td>
    </tr>
    <tr>
      <td>Меликгюх,&nbsp; Арагацотн</td>
      <td>5000</td>
    </tr>
    <tr>
      <td>Мартакерт</td>
      <td>32500</td>
    </tr>
    <tr>
      <td>Севан</td>
      <td>5100</td>
    </tr>
    <tr>
      <td>Адрут</td>
      <td>34900</td>
    </tr>
  </table>

  <table className="G-simple-table">
    <tr>
      <td><strong>Город/ село</strong></td>
      <td><strong>Стоимость доставки /драм/</strong></td>
      <td><strong>Город/ село</strong></td>
      <td><strong>Стоимость доставки /драм/</strong></td>
    </tr>
    <tr>
      <td>Ереван</td>
      <td>500</td>
      <td>Арарат</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Птгни</td>
      <td>800</td>
      <td>Меградзор</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Нубарашен</td>
      <td>1000</td>
      <td>Талин</td>
      <td>5700</td>
    </tr>
    <tr>
      <td>Прошян/село</td>
      <td>1000</td>
      <td>Анкаван</td>
      <td>6300</td>
    </tr>
    <tr>
      <td>Абовян</td>
      <td>1100</td>
      <td>Джрашен</td>
      <td>6800</td>
    </tr>
    <tr>
      <td>Звартноц</td>
      <td>1100</td>
      <td>Гавар</td>
      <td>7600</td>
    </tr>
    <tr>
      <td>Дзорахпюр</td>
      <td>1100</td>
      <td>Дилиджан</td>
      <td>7700</td>
    </tr>
    <tr>
      <td>Арамус</td>
      <td>1300</td>
      <td>Спитак</td>
      <td>7900</td>
    </tr>
    <tr>
      <td>Арзни</td>
      <td>1300</td>
      <td>Артик</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Егвард</td>
      <td>1300</td>
      <td>Маралик</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Ечмиадзин</td>
      <td>1300</td>
      <td>Арени</td>
      <td>8700</td>
    </tr>
    <tr>
      <td>Масис</td>
      <td>1300</td>
      <td>Азатан</td>
      <td>8900</td>
    </tr>
    <tr>
      <td>Нор Ачн</td>
      <td>1300</td>
      <td>Ширакаван</td>
      <td>9100</td>
    </tr>
    <tr>
      <td>Бюрегаван</td>
      <td>1500</td>
      <td>Егегнадзор</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Катнахпюр, Котайк</td>
      <td>1500</td>
      <td>Хндзореск</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Аштарак</td>
      <td>1600</td>
      <td>Чамбарак</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Нор Геги</td>
      <td>1600</td>
      <td>Ванадзор</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Мугни, Аштарак</td>
      <td>1700</td>
      <td>Ахурян</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Лусакерт</td>
      <td>1800</td>
      <td>Гюмри</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Гарни</td>
      <td>2000</td>
      <td>Мартуни</td>
      <td>10100</td>
    </tr>
    <tr>
      <td>Ошакан</td>
      <td>2000</td>
      <td>Вайк</td>
      <td>10900</td>
    </tr>
    <tr>
      <td>Азатаван</td>
      <td>2100</td>
      <td>Иджеван</td>
      <td>11200</td>
    </tr>
    <tr>
      <td>Арташат</td>
      <td>2100</td>
      <td>Амасиа</td>
      <td>11600</td>
    </tr>
    <tr>
      <td>Парпи, Арагацотн</td>
      <td>2100</td>
      <td>Мегрут</td>
      <td>11700</td>
    </tr>
    <tr>
      <td>Гегард</td>
      <td>2300</td>
      <td>Степанаван</td>
      <td>12300</td>
    </tr>
    <tr>
      <td>Чаренцаван</td>
      <td>2600</td>
      <td>Ашоцк</td>
      <td>13000</td>
    </tr>
    <tr>
      <td>Бюракан</td>
      <td>2700</td>
      <td>Варденис</td>
      <td>13200</td>
    </tr>
    <tr>
      <td>Уджан</td>
      <td>2700</td>
      <td>Ташир</td>
      <td>13700</td>
    </tr>
    <tr>
      <td>Мецамор</td>
      <td>2800</td>
      <td>Джермук</td>
      <td>14000</td>
    </tr>
    <tr>
      <td>Арзакан</td>
      <td>3100</td>
      <td>Алаверди</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Кош&nbsp;&nbsp;&nbsp; </td>
      <td>3200</td>
      <td>Ноемберян</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Бжни</td>
      <td>3300</td>
      <td>Берд</td>
      <td>16700</td>
    </tr>
    <tr>
      <td>Арагац</td>
      <td>3400</td>
      <td>Сисиан</td>
      <td>17100</td>
    </tr>
    <tr>
      <td>Аралез</td>
      <td>3400</td>
      <td>Горис</td>
      <td>19700</td>
    </tr>
    <tr>
      <td>Армавир</td>
      <td>3600</td>
      <td>Карвачар</td>
      <td>20000</td>
    </tr>
    <tr>
      <td>Агверан </td>
      <td>3700</td>
      <td>Шуши</td>
      <td>24500</td>
    </tr>
    <tr>
      <td>Раздан</td>
      <td>3700</td>
      <td>Капан</td>
      <td>25300</td>
    </tr>
    <tr>
      <td>Веди</td>
      <td>3700</td>
      <td>Каджаран</td>
      <td>25900</td>
    </tr>
    <tr>
      <td>Авшар</td>
      <td>3900</td>
      <td>Степанакерт</td>
      <td>26100</td>
    </tr>
    <tr>
      <td>Апаран</td>
      <td>4500</td>
      <td>Аскеран</td>
      <td>29300</td>
    </tr>
    <tr>
      <td>Цахкадзор</td>
      <td>4900</td>
      <td>Мартуни</td>
      <td>30500</td>
    </tr>
    <tr>
      <td>Катнахпюр, Арагацотн</td>
      <td>4900</td>
      <td>Мегри</td>
      <td>31300</td>
    </tr>
    <tr>
      <td>Меликгюх,&nbsp; Арагацотн</td>
      <td>5000</td>
      <td>Мартакерт</td>
      <td>32500</td>
    </tr>
    <tr>
      <td>Севан</td>
      <td>5100</td>
      <td>Адрут</td>
      <td>34900</td>
    </tr>
  </table>



</>;

const PrivacyPolicyText=<>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span style={{fontSize:"19px",color:"#ED7D31"}}>Приложение &laquo;Альфа-Фарм&raquo;. Политика конфиденциальности</span></strong></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><span >Приложение &laquo;Альфа-Фарм&raquo; (далее Приложение) позволяет своим пользователям пользоваться услугами ЗАО &laquo;Альфа-Фарм&raquo; с мобильных телефонов и планшетов.</span></p>
  <p><span >Конфиденциальность Вашей личной информации &nbsp;важна для нас.&nbsp;</span><span >C</span><span >облюдение конфиденциальности в отношении любой &nbsp; &nbsp;Вашей информации, которая аккумулируется в нашем приложении, является основой политики Конфиденциальности нашего приложения. &nbsp;</span></p>
  <p><span >Мы запрашиваем персональную/личную &nbsp;информацию только тогда, когда она &nbsp;действительно нужна нам для предоставления Вам какой-либо услуги. Мы собираем эту информацию &nbsp;прозрачными &nbsp; и законными средствами, с Вашего ведома &nbsp;и согласия. Мы также будем &nbsp;информировать Вас, для чего мы ее собираем и как она будет использоваться. Собранную информацию мы удерживаем на столько времени, на сколько это &nbsp;необходимо &nbsp;для предоставления &nbsp;запрошенной &nbsp; Вами &nbsp;услуги.</span></p>
  <p><span >Мы не будем использовать &nbsp;какую-либо информацию, содержащую личные данные, публично, &nbsp;или передавать ее каким-либо третьим лицам, &nbsp;- за исключением случаев, описанных в настоящей Политике Конфиденциальности либо в соответствии &nbsp;</span><span >с</span><span >&nbsp;требованиями &nbsp;законодательства.&nbsp;</span></p>
  <p><span >&nbsp;</span></p>
  <p><strong><span style={{color:"#70AD47"}}>Информация, собираемая и используемая нами</span></strong></p>
  <p><span >В целях улучшения &nbsp;практики использования нашего Приложения, &nbsp;мы можем запросить у Вас следующую идентифицируемую &nbsp;и неперсонифицированно идентифицируемую информацию:</span></p>
  <p><strong><span >&bull; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Местоположение.</span></strong><span >&nbsp;На страницах карт Приложение требует &nbsp;определение вашего местоположения (неперсонифицированная пара географических координат). Координаты необходимы &nbsp;для обозначения центра на карте в месте &nbsp;Вашего нахождения. &nbsp;Координаты не отправляются никуда &nbsp;вне пределов &nbsp;приложения. После закрытия Вами приложения, &nbsp;ваши координаты аннулируются. Если утилита&nbsp;</span><span >Android</span><span >&nbsp;&nbsp;Вашего устройства &nbsp;выполнена в версии 6 и выше, вы можете отказать в разрешении определять Ваше &nbsp;местоположение, однако следует при этом учесть, что вышеупомянутые функции работать не будут. Если версия&nbsp;</span><span >Android</span><span >&nbsp;в Вашем &nbsp;устройстве ниже 6, &nbsp;и вы не согласны предоставить свое местоположение, вы не сможете использовать приложение.&nbsp;</span></p>
  <p><span >&nbsp;</span></p>
  <div >
    <ul >
      <li ><strong><span >Знак</span></strong><strong><span >&nbsp;Google FCM</span></strong><span >&nbsp;- знак Google FCM (Firebase Cloud Messenger) - это&nbsp;</span><span >знак</span><span >, предоставляемый Google Firebase, и используемый для отправки push-уведомлений.&nbsp;</span><span >Мы берем ваш знак&nbsp;</span><span >FCM</span><span >, отправляем на наш сервер и сохраняем его там &nbsp;для будущего использования. Мы используем ваш знак для отправки&nbsp;</span><span >push</span><span >-уведомлений, и &nbsp;не будем передавать ваш знак каким бы то ни было третьим лицам.</span></li>
    </ul>
  </div>
  <p><span >&nbsp;</span></p>
  <div >
    <ul >
      <li ><strong><span >Имя, фамилия, пол, дата рождения, номер телефона, адрес электронной почты и пароль к Приложению&nbsp;</span></strong><span >-на странице регистрации Приложения Вам необходимо предоставить соответствующие данные. Мы собираем эти данные, отправляем на наш сервер и храним их там для дальнейшего использования. Эти даные &nbsp;нужны нам, чтобы иметь возможность идентифицировать Вас и предоставлять Вам &nbsp; доступ к индивидуализированным &nbsp; услугам Приложения, а также иметь возможность связываться с Вами.</span></li>
    </ul>
  </div>
  <p><span >&nbsp;</span></p>
  <div >
    <ul >
      <li ><strong><span >Сведения для онлайн-заказа товаров/продуктов, включая адрес доставки и другую информацию</span></strong><span >. Данные нужны нам для того, чтобы предоставить вам продукты, заказанные посредством Приложения.</span></li>
    </ul>
  </div>
  <p><span >&nbsp;</span></p>
  <div >
    <ul >
      <li ><strong><span >Номер &nbsp; накопительной карты, баланс и банковская &nbsp; история - в</span></strong><span >се зарегистрированные пользователи получают персональную накопительную карту. Данные нам нужны, чтобы предоставить вам возможность собирать бонусы и тратить их при совершении покупок.</span></li>
    </ul>
  </div>
  <p><span >&nbsp;</span></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span style={{color:"#70AD47"}}>Информация, собриаемая &nbsp;и используемая прочими (сторонними) службами</span></strong></p>
  <p><span >В приложении используются сторонние службы, которые могут собирать информацию, используемую для Вашей идентификации. Такая информация может &nbsp; либо собираться в базе самостоятельно, &nbsp; либо у Вас могут запросить &nbsp; предоставление &nbsp; определенной персонифицированно и неперсонифицированно идентифицируемой &nbsp;информации, включая,однако &nbsp;не ограничиваясь следующими сведениями: персональный регистрационный &nbsp; код в службе рекламы &nbsp;для&nbsp;</span><span >Android</span><span >, : персональный регистрационный &nbsp;код в службе рекламы для&nbsp;</span><span >iOS</span><span >, файлы&nbsp;</span><span >cookie</span><span >&nbsp;и аналогичные технологическкие единицы, местоположение вашего устройства, Интернет-протокол (&laquo;</span><span >IP</span><span >&raquo;) , имя устройства, версию операционной системы, конфигурацию приложения, время и дату использования приложения и другие статистические данные.&nbsp;</span><span >Поэтому мы настоятельно рекомендуем вам ознакомиться с политикой конфиденциальности этих служб. Нам не подконтрольно то, как сторонние службы собирают, используют и хранят информацию.&nbsp;</span><span >Следовательно, ответственности за услуги, предоставляемые &nbsp; третьми сторонами, мы не несем.</span></p>
  <p><span >&nbsp;</span></p>
  <p><span >Перечень услуг прочих (стороних) служб, используемых Приложением, и ссылки на политику конфиденциальности &nbsp;этих служб:</span></p>
  <div >
    <ul >
      <li ><strong><span >Google</span></strong><strong><span >&nbsp;</span></strong><strong><span >Maps</span></strong><strong><span >&nbsp;</span></strong><strong><span >API</span></strong><span >&nbsp;</span><span >&ndash; используется для показа карт&nbsp;</span><strong><span >Google</span></strong></li>
    </ul>
  </div>
  <p><span >&nbsp;</span></p>
  <div >
    <ul >
      <li ><strong><span >Google Firebase</span>&nbsp;</strong><strong><span >-&nbsp;</span></strong><span >используется для сбора неперсонифицированно &nbsp; &nbsp;идентифицируемых аналитических данных, сбоев в работе приложений и журналов ошибок, а также для отправки push-уведомлений</span></li>
    </ul>
  </div>
  <p ><span >&nbsp;</span></p>
  <p><span >Все вышеупомянутые услуги предоставляются&nbsp;</span><span >Google</span><span >, и вы можете найти политику конфиденциальности &nbsp;предоставления услуг в Политике конфиденциальности&nbsp;</span><span >Google</span><span >&nbsp;(</span><span ><a href="https://policies.google.com/privacy" target="_blank"><span style={{color:"#0563C1"}}>Google</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>Privacy</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>Policy</span></a></span><span >). Поскольку приложение использует&nbsp;</span><span >API</span><span>&nbsp;</span><span >(Application Programming Interfaces &ndash;интерфейсы программирования приложений)</span><span >&nbsp;</span><span >&nbsp;Карт&nbsp;</span><span >Google</span><span >, &nbsp;то используя это приложение, вы &nbsp;будете также связаны Условиями использования&nbsp;</span><span >Google</span><span >&nbsp;(</span><span ><a href="https://policies.google.com/terms" target="_blank"><span style={{color:"#0563C1"}}>Google</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>Terms</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>of</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>Service</span></a></span><span >) и любыми другими действующими условиями и политиками&nbsp;</span><span >Google</span><span >. Если вы не согласны с условиями и политикой, Вы не должны использовать Приложение.</span></p>
  <div >
    <ul >
      <li ><strong><span >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></strong><strong><span >ArCa</span></strong><strong><span >&nbsp;</span></strong><strong><span >API</span></strong><span >&nbsp;</span><span >- используется для осуществления оплаты заказов с использованием банковских карт. Если вы хотите оплатить заказ с помощью банковской карты, вам необходимо предоставить данные своей банковской карты. Данные заполняются на веб-странице&nbsp;</span><span >ArCa</span><span >, открываемой посредством Приложения. Веб-страница находится вне Приложения, и у нас нет возможности получить доступ к данным, заполненяемым &nbsp;на веб-странице. Данные будут отправлены в&nbsp;</span><span >ArCa</span><span >&nbsp;</span><span >API</span><span >. Затем&nbsp;</span><span >ArCa</span><span >&nbsp;проверит, есть ли у вас необходимая сумма на балансе вашей карты, и передаст &nbsp;сумму оплаты &nbsp;заказа в ЗАО &laquo;Альфа-Фарм&raquo;. Данные карты в приложении фигурировать не будут. Если вы не хотите предоставлять данные своей банковской карты, вы можете выбрать другие способы оплаты.</span></li>
    </ul>
  </div>
  <p><span >&nbsp;</span></p>
  <p><span >Для получения дополнительной информации о Политике конфиденциальности&nbsp;</span><span >ArCa</span><span >, пожалуйста перейдите на сайт (</span><span ><a href="https://www.arca.am/" target="_blank"><span style={{color:"#0563C1"}}>ArCa</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>website</span></a></span><span >).&nbsp;</span></p>
  <p><span >&nbsp;</span></p>
  <div >
    <ul >
      <li ><strong><span >Hostgator</span></strong><strong><span >&nbsp;</span></strong><strong><span >Hosting</span></strong><strong><span >&nbsp;</span></strong><strong><span >Services</span></strong><span >&nbsp;</span><span >-Мы используем хостинг-услуги&nbsp;</span><span >Hostgator</span><span >&nbsp;для хранения данных наших пользователей. &nbsp;Политику конфиденциальности при предоставлении &nbsp;различных услуг &nbsp;вы найдете в политике конфиденциальности&nbsp;</span><span >Hostgator</span><span >&nbsp;(</span><span ><a href="https://www.endurance.com/privacy/privacy" target="_blank"><span style={{color:"#0563C1"}}>Hostgator</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>Privacy</span><span style={{color:"#0563C1"}}>&nbsp;</span><span style={{color:"#0563C1"}}>Policy</span></a></span><span >). Если вы не согласны с политикой, вы не должны использовать приложение</span></li>
    </ul>
  </div>
  <p><strong><span style={{color:"#70AD47"}}>Файлы Куки (</span></strong><strong><span style={{color:"#70AD47"}}>Cookies</span></strong><strong><span style={{color:"#70AD47"}}>)</span></strong></p>
  <p><span >Файлы&nbsp;</span><span >cookie</span><span >&nbsp;представляют собой файлы, содержащие &nbsp;небольшое количество данных, которые, как правило, &nbsp;используются в качестве анонимных &nbsp;уникальных идентификаторов. Они могут быть отправлены на ваше устройство и сохранены в его внутренней памяти. Мы не используем куки, однако &nbsp;прочие (сторонние службы) могут использовать файлы&nbsp;</span><span >cookie</span><span >&nbsp;для сбора информации и усовершенствования своих услуг. Чтобы узнать больше о том, как прочие/сторонние службы используют файлы&nbsp;</span><span >cookie</span><span >, ознакомьтесь с политиками конфиденциальности прочих/сторонних служб</span></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span style={{color:"#70AD47"}}>Безопасность</span></strong></p>
  <p>Мы ценим ваше доверие, выражающееся в предоставлении вашей персональной информации нам и нашим партнерам-поставщикам услуг поэтому мы всегда &nbsp;стремимся использовать коммерчески приемлемые методы &nbsp;ее защиты. Тем не менее помните, что ни один способ передачи информации посредством &nbsp;Интернета, или метод электронного хранения &nbsp;не является стопроцентно &nbsp;безопасным и надежным, и мы не можем гарантировать абсолютную безопасность Вашей информации.&nbsp;</p>
  <p>&nbsp;</p>
  <p><strong><span style={{color:"#70AD47"}}>Ссылки на другие сайты и приложения&nbsp;</span></strong></p>
  <p><span >Настоящее &nbsp;приложение может содержать ссылки на другие веб-сайты и приложения. Если вы нажмете на такую ссылку, вы будете перенаправлены на такие &nbsp;сайты или приложения. Обратите внимание, что указанные внешние веб-сайты и приложения не управляются нами. Поэтому мы настоятельно рекомендуем вам ознакомиться с условиями использования и политикой конфиденциальности этих веб-сайтов и приложений. Мы не контролируем и не несем ответственности за содержание, условия использования, политику конфиденциальности или действия прочих/сторонних веб-сайтов, приложений или сервисов.&nbsp;</span></p>
  <p><span >&nbsp;</span></p>
  <p><strong><span style={{color:"#70AD47"}}>Согласие с &nbsp; настоящей Политикой конфиденциальности&nbsp;</span></strong></p>
  <p><span >Использование Приложения вами будет &nbsp;считаться согласием с Политикой Конфиденциальности, сбором и использованием информации относительно данной политики. &nbsp;&nbsp;</span></p>
  <p><span >&nbsp;</span></p>
  <p><strong><span style={{color:"#70AD47"}}>Изменения в настоящей Политике конфиденциальности&nbsp;</span></strong></p>
  <p>Мы можем периодичеки&nbsp;<span >&nbsp;обновлять нашу Политику конфиденциальности. Поэтому рекомендуем Вам просматривать время от времени &nbsp;эту страницу на предмет каких-либо &nbsp;изменений. При публикации &nbsp;новой Политики конфиденциальности, мы обязательно сообщим Вам &nbsp;на этой странице обо всех изменениях. Такие &nbsp;изменения вступают в силу сразу же после их публикации на данной странице.</span></p>
  <p><span >&nbsp;</span></p>
  <p><strong><span style={{color:"#70AD47"}}>Связь</span></strong><strong><span style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span style={{color:"#70AD47"}}>с</span></strong><strong><span style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span style={{color:"#70AD47"}}>нами</span></strong></p>
  <p><span >Если у вас есть какие-либо вопросы или предложения по поводу настоящей &nbsp;Политики конфиденциальности, обращайтесь к нам незамедлительно.&nbsp;</span></p>
  <p><span >&nbsp;</span></p>
  <p><strong><span style={{color:"#70AD47"}}>Дата вступления политики в силу</span></strong></p>
  <p><span >Настоящая Политика &nbsp;вступает в силу с &nbsp;17 октября &nbsp;2018 года.</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#ED7D31"}}>Условия</span></strong><strong><span style={{fontSize:"21px",color:"#C45911"}}>&nbsp;</span></strong><strong><span style={{fontSize:"21px",color:"#ED7D31"}}>использования приложения Alfa-Pharm</span></strong></p>
  <p ><strong><span style={{color:"#70AD47"}}>Введение</span></strong></p>
  <p ><span >Благодарим вас за использование приложения AlfaPharm (далее также Приложение).</span></p>
  <p ><span >Приложение является безвозмездной услугой ЗАО &laquo;Альфа-Фарм&raquo;, которая доступна по адресу: Ереван, Ширака 1/68,</span></p>
  <p ><span >Использование приложения должно соответствовать условиям использования Приложения (далее &laquo;Условия&raquo;).</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Доступ к информации и использование:</span></strong></p>
  <p ><span >Вы можете использовать приложение в вашем мобильном телефоне (далее &nbsp;&laquo;</span><span >Устройство</span><span >&raquo;) для</span><span >&nbsp;использования,&nbsp;</span><span >просмотра, поиска услуг аптечной сети ЗАО &laquo;Альфа-Фарм&raquo;</span><span >, а также при</span><span >&nbsp;обработк</span><span >е</span><span >&nbsp;онлайн-</span><span >заказаов.</span></p>
  <p ><span >ЗАО &laquo;Альфа-Фарм&raquo; не несет никакой ответственности за любую информацию об аптечной сети ЗАО &laquo;Альфа-Фарм&raquo;, которая доступна с помощью другого приложения</span><span>.&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Обновления</span></strong></p>
  <p ><span >Структура и информация приложения могут нуждаться в обновлении, например, исправления ошибок, расширения, плагины или новые версии (в совокупности &laquo;Обновления&raquo;). Такие обновления могут потребоваться, чтобы Вы могли использовать приложения. Принимая эти условия и используя приложение, Вы соглашаетесь с автоматическими обновлениями, перечисленными выше.</span></p>
  <p ><strong><span style={{fontSize:"16px",color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Покупки и платежи: Закупка лекарств (медикаментов, медицинских принадлежностей и непродовольственных товаров, детского питания)</span></strong></p>
  <p ><span >Как только Вы приобретаете продукт через приложение, Вы подписываете отдельную сделку для этих условий (если применимо) с продавцом, который является ЗАО &laquo;Альфа-Фарм&raquo;.</span></p>
  <p ><span >Отдельная сделка при покупке является дополнением к этим условиям.</span></p>
  <p ><span >Сделка покупки товара считается</span><span >&nbsp;</span><span >выполненной &nbsp;в тот момент, когда вы получаете сообщение, подтверждающее покупку продукта, и эта сделка вступит в силу сразу же после завершения покупки.</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Предварительные заказы</span></strong></p>
  <p ><span >Когда вы размещаете предварительный заказ для продукта, сделка покупки для этого продукта будет подписана</span><span >&nbsp;только тогда,&nbsp;</span><span >когда вы получите сообщени</span><span >е&nbsp;</span><span >на подтверждение заказа со стороны компании.</span></p>
  <p ><span >Мы должны будем отменить ваш заказ,&nbsp;</span><span >в том случае, если до заказа изменились цены и</span><span >ли товар вычитается из продажи через приложение.</span></p>
  <p ><strong><span>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Способы оплаты:</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Способы оплаты:</span></strong></p>
  <p ><span >Вы можете выбрать один из способов оплаты при покупке товара через приложение:</span></p>
  <p ><span >&nbsp;</span></p>
  <ul >
    <li><span>Наличными средствами в момент доставки</span><span>,</span></li>
    <li><span>Через&nbsp;</span><span>б</span><span >анковский терминал в момент доставки</span><span>,</span></li>
    <li><span>Онлайн, с помощью приложения</span><span>.</span></li>
  </ul>
  <p><span>&nbsp;</span></p>
  <p ><span >При оплате банковской картой вы должны соблюдать контракт третьей стороны или другое юридическое соглашение, которое регулирует использование метода оплаты.</span></p>
  <p ><span >Вы несете полную ответственность за все платежи, внесенные вами в Приложении.</span></p>
  <p ><strong><span style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Цены</span></strong></p>
  <p ><span >Цена и доступность продукта, описанного в Приложении, могут быть изменены в любое время до покупки.</span></p>
  <p ><span >По техническим причинам м</span><span >огут быть малейшие&nbsp;</span><span >&nbsp;расхождения в с</span><span >вязи с фото и ценами на товары.</span></p>
  <p ><span >В случае разницы в цене и / или несоответствия вы можете позвонить по номеру +374 60 700 500. 1, &nbsp; или сообщить о проблеме письменно на официальный адрес электронной почты ЗАО &laquo;Альфа-Фарм&raquo; <span  style={{listStyleType: "undefined",color:"#0563C1"}}><a href="mailto:online@alfapharm.am">online@alfapharm.am</a></span>.</span></p>
  <p ><strong><span style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Все продажи являются окончательными</span></strong></p>
  <p ><span >Все продажи являются окончательными, а возврат, обмен и постоплата не совершаются, за исключением случаев неточной информации о продуктах, вызывающихся ошибками из-за технических проблем в момент покупки, а также в сроки, установленные законодательством РА и возвратом товаров. Если для сделки предназначены замена, возврат или постоплата, то возможна ее отмена.</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#ED7D31"}}>Права и обязанности</span></strong></p>
  <p ><strong><span style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Пользователь приложения имеет право:</span></strong></p>
  <ul style={{listStyleType: "undefined"}}>
    <li><span>И</span><span >спользօвать приложение бесплатно,</span></li>
    <li><span>Просматривать, находить информацию в приложении,</span></li>
    <li><span>С помощью приложения покупать товары ЗАО&nbsp;</span><span  style={{listStyleType: "undefined"}}>&laquo;</span><span>Альфа-Фарм</span><span >&raquo;</span><span>, которые указаны в приложении, &nbsp;</span></li>
    <li><span>Отменять</span><span >&nbsp;заказ на пок</span><span>упку</span><span >&nbsp;до получения подтверждающего сообщения,</span></li>
  </ul>
  <p><span>▪&nbsp;</span><span>&nbsp; &nbsp;&nbsp;</span><span>Получать точную информацию о</span><span>б</span><span>&nbsp;аптечной сети ЗАО &laquo;Альфа-Фарм&raquo;,</span></p>
  <p><span>▪&nbsp;</span><span>&nbsp; &nbsp;&nbsp;</span><span>Получать информацию о &nbsp;&nbsp;</span><span>накопительной&nbsp;</span><span>карте, если таковая имеется,</span></p>
  <p><span>▪&nbsp;</span><span>&nbsp; &nbsp; &nbsp; В случяе наличия</span><span>, использов</span><span>ать&nbsp;</span><span>данные накопительной карты для накопления&nbsp;</span><span>бонусных&nbsp;</span><span>баллов в аптечной сети ЗАО &laquo;Альфа-Фарм&raquo;</span></p>
  <p><span>▪&nbsp;</span><span>&nbsp; &nbsp; &nbsp; В случае наличия, и</span><span>спольз</span><span>овать</span><span>&nbsp;</span><span>бонусы</span><span>, имеющиеся на накопительной к</span><span>арте,</span><span>&nbsp;при совершении покупок в аптечной сети ЗАО &laquo;Альфа-Фарм&raquo;.</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Пользователь приложения обязан:&nbsp;</span></strong></p>
  <p ><span >Предоставлять точную информацию при регистрации в Приложении и при заказе продукта,</span></p>
  <p ><span >Отменять заказы на покупку до получения подтверждающего сообщения.</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>ЗАО &laquo;Альфа-Фарм&raquo; имеет право</span></strong><span style={{fontSize:"21px",color:"#70AD47"}}>:</span></p>
  <p ><span >Собирать &nbsp; информацию о пользователей (имя, фамилия, адрес электронной почты, адрес доставки),</span></p>
  <p ><span >Предостав</span><span >ля</span><span >ть собранную информацию соответствующим подразделениям ЗАО &laquo;Альфа-Фарм&raquo; для доставки товаров.</span></p>
  <p ><strong><span style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span style={{color:"#70AD47"}}>ЗАО &laquo;Альфа-Фарм&raquo; обязано:</span></strong></p>
  <p ><span >Ввести в приложение точную информацию,</span></p>
  <p ><span >Доставлять качественные продукты,</span></p>
  <p ><span >В случае наличия накопительной карты и по просьбе пользователя приложения накапливать в &nbsp; карту бонусные очки,</span></p>
  <p ><span >Принимать отмену заказа, если он был совершен до начала процесса доставки,</span></p>
  <p ><span >Не предоставлять информацию о пользователях третьим лицам.</span></p>
  <p ><span>&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Условия получения и доставки заказа</span></strong></p>
  <p ><span >▪ Доставка осуществляется по всей територии Еревана,</span></p>
  <p ><span >▪ Заказы принимаются и доставляются во все дни недели &ndash; 24 часа в сутки,</span></p>
  <p ><span >▪ Минимальная цена заказа должна составлять 2 000 драм,</span></p>
  <p ><span >▪ Цена доставки на заказ до 10 000 драмов составляет 500 драмов,</span></p>
  <p ><span >▪ Заказы на сумму более 10000 драмов доставляются бесплатно,</span></p>
  <p ><span >▪ Наши фармацевты-операторы доступны 24 часа в сутки по номеру 060 700 500. 1 ,</span></p>
  <p ><span >▪ После получения заказа наш фармацевт-оператор свяжется с вами, чтобы уточнить детали вашего заказа.</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Условия оплаты:</span></strong></p>
  <p ><span >Оплата может быть произведена:</span></p>
  <p ><span >▪ Наличными средствами в момент доставки,</span></p>
  <p ><span >▪ Через банковский терминал в момент доставки,</span></p>
  <p ><span >▪ Онлайн, с помощью приложения.</span></p>
  <p ><span>&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Условия возврата:</span></strong></p>
  <p ><span >От доставленного заказа и его оплаты можно отказаться только в следующих случаях:</span></p>
  <p ><span >Доставленный продукт отличается от заказанного продукта,</span></p>
  <p ><span >▪ Упаковка продукта повреждена,</span></p>
  <p ><span >▪ Условия хранения товаров были нарушены во время перевозки,</span></p>
  <p ><span >▪ Продукт подлежит возврату только во время доставки.</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><strong><span style={{fontSize:"21px",color:"#70AD47"}}>Изменени</span></strong><strong><span style={{fontSize:"21px",color:"#70AD47"}}>е</span></strong><strong><span style={{fontSize:"21px",color:"#70AD47"}}>&nbsp;</span></strong><strong><span style={{fontSize:"21px",color:"#70AD47"}}>выше перечисленных условий</span></strong></p>
  <p ><span >В случае изменения настоящих условий Вы получите уведомление, и новые условия вступят в силу с момента уведомления.</span><span >&nbsp;</span><span >Новые условия будут применяться к использованию Вами всей информации и всех последующих &nbsp;закупок.</span></p>
  <p ><span >Если Вы не согласны с такими изменениями, Вам будет предоставлена возможность прекратить использование приложения.</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><span >&nbsp;</span></p>
</>

const faqTexts = [{
  title: "Возврат товара",
  description: <>
    Возврат осуществляется в течение 14 дней со дня покупки. Можете вернуть доставленный товар в офисе Ineed. Необходимо представить паспорт и товарный чек.
  </>,
}, {
  title: "Регистрация",
  description: <>
    <b>Как зарегистрироваться.</b><br />
    Для регистрации нажмите на клавишу “регистрация”, впишите нижеуказанные поля и, вновь, нажмите в нижнем отделе “регистрация”, после заполнения  на вашу электронную почту будет отправлено письмо для активации регистрации. Регистрация в системе вам поможет иметь собственную страницу, где впоследствии можете увидеть историю ваших покупок, и, в качестве постоянного покупателя получать информацию о новостях на сайте.<br /><br />
    <b>Могу ли я зарегистрироваться с помощью других систем?</b><br />
    Вы можете зарегистрироваться при помощи социальных сетей: Facebook, Google+.<br /><br />
    <b>Возможно ли сделать покупку без регистрации?</b><br />
    Да, возможно, вы можете пропустить поле “регистрация” и совершить покупки в качестве гостя, однако история ваших покупок не сохранится в системе.<br /><br />
    <b>Я забыл пароль регистрации.</b><br />
    Нажмите на клетку “забыли пароль” и получите сообщение  на ваш электронный адрес.
  </>,
}, {
  title: "Ассортимент товаров",
  description: <>
    <b>Как мне найти необходимый товар?</b><br />
    “Что вам нужно?”, на этом поле заполните наименование товара, единицу измерения, количество. Можно также описать товар в соответствующем разделе, а также прикрепить фотографии, файлы, чертежи. Нажмите  клавишу  “заказать” и мы рассмотрим заказ, и обратно отправим ценовое предложение.<br /><br />
    <b>Как оплатить?</b><br />
    Оплатить можно:<br />
    Наличными, непосредственно  курьеру;<br />
    Онлайн, по одному из указанных на сайте способов;<br />
    Переводом, на основе счет-фактуры.<br /><br />
    <b>Могу ли получить счет-фактуру?</b><br />
    Для получения счет-фактуры необходимо отметить в поле “дополнение”, либо позвонить по номеру 011200900.<br /><br />
    <b>Могу ли заплатить из-за границы, иностранными картами?</b><br />
    Оплату можно произвести в любой точке мира по системе IDRAM,VIZA,MASTER,ARCA картами(необходимо иметь виртуальную регистрацию)
  </>,
}, {
  title: "Доставка",
  description: <>
    <b>В какие сроки производится доставка?</b><br />
    Доставка производится в течение 1-2х рабочих дней(доставки начинаются с 09.00 до21.00,кроме воскресенья).<br /><br />
    <b>Я желаю, чтобы доставку произвели  на несколько дней позже.</b><br />
    При покупке в сети  возможна доставка по вашему желанию в течение 7 рабочих дней, для чего необходимо при заполнении четко указать день и час доставки.<br /><br />
    <b>Каковы условия платной доставки?</b><br />
    Мы предлагаем оптимальную тарифную систему, согласно которой при покупке выше определенной суммы, доставка осуществляется бесплатно, в иных случаях сумма будет вычислена по установленному тарифу .Для ознакомления с прейскурантом, зайдите на сайт “О нас-как мы производим доставку”.<br /><br />
    <b>Я получил товар, а потом выяснилось, что есть повреждения, либо товар оказался неполным.</b><br />
    Во время доставки необходимо проверить качественное и количественное состояние товара(повреждения, неполный товар), и, в этом случае не принимаете данный товар, в счет-фактуре производится соответствующая запись, затем, в течение 1 рабочего дня товар заменяется новым.<br /><br />
  </>,
}];

const specialProductsHelp = <>
  <p>"Альфа Фарм" дает своим клиентам возможность накапливать бонусы на приобретении лекарств, косметики или других медицинских продуктов.</p>
  <p>У вас может быть максимум 2 специальных продукта, и накопление по ним составит 6%.</p>
  <p>Специальные продукты можно менять раз в 3 месяца, а у продуктов детской категории - раз в месяц.</p>
  <p>Некоторые продукты являются исключениями, они не могут быть выбраны как "специальные продукты.</p>
</>

export default {
  alfa_pharm: 'Альфа-Фарм',
  bonusayin_cragir:'Альфа-Фарм сеть аптек 01.11.2016 г.компания запустила бонусную программу поощрения клиентов, которая дает возможность клиентам, совершая покупки в аптеках Альфа-Фарм, накапливать за них баллы и тратить деньги в аптеках Альфа-Фарм при последующих покупках',
  karoqeq__gnum_katarel:'Альфа-карту" можно приобрести при покупке в любом филиале аптек Альфа-Фарм.',
  alfa_bonusayin_ctagir:'Альфа-карта - бонусная программа',
  alfa_text1:'Накопительная бонусная программа "альфа карт" предоставляет клиентам возможность совершать покупки в аптеках Альфа-Фарм, получать на них очки и тратить их по частям или полностью(1 единица эквивалентна 1 драму).',
  alfa_text2:'Предоставляя "Альфа-карту", набирайте очки по следующей шкале:',
  point_1: '2 балла за каждые 100 драмов при единовременной покупке до 10 000 драмов.',
  point_2:'3 балла за каждые 100 драмов при единовременной покупке от 10,000 до 20,000 драмов',
  point_3:'5 баллов за каждые 100 драмов при единовременной покупке в размере 20 000 драмов и более',
  point_4:'+1 дополнительный балл за каждые 100 драмов - 40,000 драмов и более при единовременной покупке',
  point_5:'+1 дополнительный балл за каждые 100 драм при покупках по воскресеньям',
  barcr_miavorner:'Также у вас есть возможность накапливать высокие баллы`',
  barcr_miavorner_1:'Выберите любые 2 специальных продукта и получите 6 фиксированных баллов за каждые 100 драмов. Специальные товары можно менять раз в 3 месяца, а специально подобранные детские - раз в месяц.',
  barcr_miavorner_2:'Накапливайте особые высокие баллы за каждые 100 драмов при покупке товаров следующих марок:',
  standart_kutakman_sandxak:'В случае вышеуказанных накоплений стандартная шкала накопления не действует.',
  info_price_1:'* Низкие баллы могут быть предоставлены или вообще не предоставлены для некоторых товарных групп, установленных компанией, которые обычно продаются по низким ценам или с особой скидкой:',
  info_price_2:'* При отдельных акциях условия их накопления устанавливаются отдельно',
  info_price_3:'* В случае действующих скидок при использовании «Альфа-карты» скидка на товар не распространяется и будет накапливаться по стандартной шкале накоплений в соответствии с суммой совершенной покупки.\n',
  info_price_4:'* При использовании накопленных баллов за них не накапливаются новые баллы.',
  info_cart_1:'Если вы не используете карту более года, она будет заблокирована, а баллы будут обнулены.',
  info_cart_2:'Альфа-карта бонусная программа для корпоративных клиентов',
  info_cart_3:'Накопительная программа бонусов корпоративных клиентов «Альфа-Кард» позволяет покупателям совершать покупки в аптеках «Альфа-Фарм», накапливать за них баллы и тратить их частично или полностью (1 балл эквивалентен 1 драму РА). Баллы начисляются в зависимости от разовые покупки клиента от суммы по следующей шкале.',
  point_6:'6 баллов за каждые 100 драмов при единовременной покупке до 10 000 драмов',
  point_7:'7 баллов за каждые 100 драмов при единовременной покупке от 10,000 до 20,000 драмов',
  point_8:'9 баллов за каждые 100 драмов при единовременной покупке в 20 000 драмов и более',
  qartapan_info:'Владелец карты имеет возможность накапливать высокие баллы.',
  info_point_1:'Выбирая любые 2 специальных продукта, вы получаете фиксированные 6 баллов за каждые 100 драмов. Специальные товары можно менять раз в 3 месяца, а специально подобранные детские - раз в месяц.',
  info_point_2:'будут накапливаться специальные высокие баллы за каждые 100 драмов при покупке товаров следующих марок:',







  special_products_help: specialProductsHelp,
  special_product: "Особый товар",
  special_product_confirm: 'Вы уверены, что хотите сделать этот товар особенным?',
  expired_text: "Срок истек",
  expire_text: "Срок подходит к концу",
  price_offer: "Получить ценовое предложение",
  card_info_title: 'Ինչ է Ալֆա Քարտը',
  card_info: cardInfo,
  date_new_to_old: "Новинки",
  added: "Добавлено",
  verificationCode: "Код подтверждения",
  language_label: "Рус",
  i_need: "Мне необходимо...",
  wish_list: "Списки",
  favorites: "Избранные",
  orders: "Заказы",
  product_of_the_day: "Товар дня",
  order_history: "История заказов",
  cart: "Корзина",
  contact_address: "РА , Ереван, ул. Ширак 1/68",
  log_in: "Войти",
  log_in_title: "Войти",
  filter: "Фильтр",
  all_categories: "Все разделы",
  about_us: "О нас",
  about_us_first_1: "Фармацевтическая компания \"Альфа-Фарм\" основана в 1996 г.. В настоящее время она занимает ведущее положение на фармацевтическом рынке Армении. Компания уже более 20-и лет успешно занимается импортом, оптовой и розничной торговлей фармацевтической продукции.  ",
  about_us_first_3: "Компания имеет прямые поставки от 100 мировых ведущих производителей в том числе из России, стран СНГ, Европы, США, Индии, и одновременно сотрудничает с местными дистрибьюторами, что позволяет обеспечить более широкий ассортимент. Нашими партнерами являются такие компании как \"Les Laboratories Servier\", \"Sanofi-Aventis\", \"Abbott\”, \"Berlin-Chemie AG\", \"Novartis Consumer\", \"Bayer Consumer\",  \"Hoffman-La Roche\", \"Nycomed Austria\”, \"Pfizer\" и другие.",
  about_us_first_2: "Учредитльями компании являются специалисты имеющие многолетний опыт на фармацевтическом рынке в Республике Армения, благодаря профессиональным  и организационным навыкам которых компания предоставляет высококачественные услуги обществу. В разные периоды акционерами \"Альфа-Фарм\" были \"Европейский банк реконструкции и развития\" (EBRD) и другие крупные европейские инвесторы.",


  about_clinic: 'О клинике',
  doctor: "Доктор",
  doctor_consultation: "Совет Доктора",
  service: "Сервис",
  services: "Сервисы",
  services_text: "«Ալֆա Ֆարմ» ընկերության մեծածախ վաճառքի բաժնի հիմնական նպատակը ՀՀ բոլոր դեղատներին որակյալ դեղորայքով, հիգիենայի պարագաներով, մանկական սննդով և անհրաժեշտ այլ տեսականիով ապահովելն է: Մենք առաջարկում ենք ծառայություններ հետևյալ առավելություններով`",
  business: "Бизнес",
  become_partner: "Стать партнером",
  how_to_become_a_partner: "Как стать партнером",
  vacancies: "Вакансия",
  financial_statements: "Финансовые отчеты",
  fs1: 'Годовой финансовый отчет ЗАО “Альфа-Фарм” за 2022 год.',
  fs2: 'Годовой финансовый отчет ЗАО “Альфа-Фарм Импорт” за 2022 год.',
  fs3: 'Годовой финансовый отчет группы ЗАО “Альфа-Фарм” (сгруппированный) за 2022 год.',
  fs4: 'Годовой финансовый отчет ЗАО “Альфа-Фарм” за 2023 год.',
  fs5: 'Годовой финансовый отчет группы ЗАО “Альфа-Фарм” (сгруппированный) за 2023 год.',
  fs6: 'Годовой финансовый отчет ЗАО “Альфа-Фарм Импорт” за 2023 год.',
  how_to_order_online: "Как заказать онлайн",
  how_to_order_online_text: "Օնլայն գնում կատարելու համար կարող եք գրանցվել և մուտք գործել համակարգ, ինչը հնարավորություն կտա ստեղծել ձեր անձնական հաշիվը, որտեղ.",
  how_to_order_online_text_li_1: "կհետևեք պատվերի ընթացքին,",
  how_to_order_online_text_li_2: "կպահպանվի ձեր պատվերների պատմությունը,",
  how_to_order_online_text_li_3: "անվճար ձեռք կբերեք կուտակային քարտ,",
  how_to_order_online_text_li_4: "կպահպանեք նախընտրելի ապրանքների ցանկը,",
  how_to_order_online_text_li_5: "և շատ այլ հնարավորություններ կստանաք:",
  how_to_order_online_text_2: "Կարող եք օնլայն գնում կատարել նաև առանց կայք մուտք գործելու՝ մասնավորապես․",
  how_to_order_online_text_2_li_1: "Ներբեռնելով «Alfa-Pharm» բջջային հավելվածը",
  how_to_order_online_text_2_li_2: "Ուղարկելով հաղորդագրություն մեր սոցցանցերի էջերին կամ",
  how_to_order_online_text_2_li_3: "Զանգահարելով 060 700 500 ներք․ 1 հեռախոսահամարով",
  how_to_order_online_text_2_li_4: "Պատվիրել կայքի միջոցով, որպես հյուր (առանց օգտահաշիվ մուտք գործելու)։",
  how_to_order_online_text_3: "-ում օնլայն գնելու համար անհրաժեշտ է․",
  how_to_order_online_text_3_li_1: "Սեղմել «Օնլայն դեղատուն» ⇒ ընտրել ձեզ անհրաժեշտ կատեգորիան կամ փնտրել անհրաժեշտ ապրանքը որոնման դաշտում,",
  how_to_order_online_text_3_li_2: "Ընտրել ապրանքը",
  how_to_order_online_text_3_li_3: "Ընտրել քանակը (տուփ/հատ),",
  how_to_order_online_text_3_li_4: "Սեղմել «ավելացնել» կոճակը,",
  how_to_order_online_text_3_li_5: "Նշել առաքման հասցեն կամ նշել դեղատունը որտեղից ցանկանում եք վերցնել պատվերը,",
  how_to_order_online_text_3_li_6: "Նշել առաքման նախընտրելի ժամը կամ նշել «հնարավորինս շուտ»,",
  how_to_order_online_text_3_li_7: "Ընտրել վճարման տեսակը,",
  how_to_order_online_text_3_li_8: "Սեղմել «հաստատել» կոճակը։",
  how_to_order_online_text_4: "Մեր առաքիչն օպերատիվ կերպով կառաքի Ձեր գնումը նշված հասցեով։",
  how_to_order_online_information: "Տեղեկացնում ենք նաև, որ օնկոլոգիական հիվանդությունների բուժման համար նախատեսված դեղամիջոցները Ալֆա-Ֆարմի օնլայն դեղատան միջոցով ենթակա չեն վաճառքի և չեն առաքվում։ Օնկոլոգիական հիվանդությունների բուժման համար նախատեսված դեղորայքը ձեռք բերելու համար կարող եք մոտենալ Ալֆա-Ֆարմի ք․ Երևան Մ․ Մաշտոցի 31/10 և ք․ Երևան Խ․ Աբովյան 38 հասցեների մասնաճյուղեր։",
  how_to_order_online_information_text_1: "Արդյո՞ք գնված դեղորայքը ենթակա է ետ վերադարձի․",
  how_to_order_online_information_text_2: "ՀՀ կառավարության 2002 թվականի հունվարի 30-ի N 77 որոշմամբ ",
  how_to_order_online_information_text_3: "նմանօրինակ ապրանքներով փոխարինվելու կամ վերադարձնելու ոչ ենթակա պատշաճ որակի ոչ պարենային ապրանքների ցանկում են ներառվել նաև․",
  how_to_order_online_information_text_4: "տնային պայմաններում հիվանդությունների կանխարգելման և բուժման համար (մետաղից, ռետինից, տեքստիլ և այլ նյութերից առողջարարության (կազդուրիչ) և հիգիենայի առարկաներ, բժշկական գործիքներ, սարքեր ու ապարատներ, բերանի խոռոչի հիգիենայի միջոցներ, տեսողության լինզաներ, երեխաների խնամքի առարկաներ), դեղորայք,",
  how_to_order_online_information_text_5: "անձնական հիգիենայի առարկաներ (ատամի խոզանակներ, սանրեր, մազակալներ, բիգուդիներ, կեղծամներ, շինյոններ և այլն),",
  how_to_order_online_information_text_6: "պարֆյումերակոսմետիկական ապրանքներ՝ բացառությամբ օծանելիքի։",
  what_is_alfa_card: "Что такое Альфа карта",
  contact_us: "Обратная связь",
  default: "По умолчанию",
  make_default: "Использовать по умолчанию",
  copyright: "Все права защищены",
  enter_your_phone_number: "Введите номер телефона",
  contract: "Контракт",
  faq: "Часто задаваемые вопросы",
  faq_texts: faqTexts,
  confidentiality_conditions: "Условия конфиденциальности",
  products_exchange_and_return: "Обмен и возврат товаров",
  download_application: "Скачать заявку",
  download_text: "Зарегистрируйтесь и получите 5000 iBonus",
  not_a_member: "Если еще не зарегистрированы",
  a_member: "Если у вас есть активная учетная запись",
  sign_up: "Регистрация",
  book: "Бронировать",
  email: "Эл. адрес",
  password: "Пароль",
  restore_password: "Восстановить пароль?",
  social_login: "Регистрация с личной страницей",
  already_a_member: "Уже вступил?",
  next: "Следующий",
  next_step: "Следующий",
  aply: "Применить",

  accumulative_bonus: "Накопленный бонус",
  accumulative_bonus_master_card: "Двойной бонус пo оплате картой Mastercard ",
  accumulative_bonus_visa_card: "Стоимость со скидкой при оплате картой VISA",
  accumulative_bonus_visa_card_guest: "Для действия скидки необходимо ",
  order: "Заказ",
  fill_your_information: "Заполните вашу информацию",
  order_checkout: "Оформления заказа",
  add: "Добавить",
  add_credit_card: "+Добавить новую карту",
  delete_credit_card: "Вы хотите удалить сохраненную карту ?",
  what_do_you_need_today: "Что Вам необходимо сегодня?",
  today: "Сегодня",
  appointments_cancel: "Отменить запись",
  appointments_cancel_text: "Вы уверены, что хотите отменить запись?",
  prescription_delete: "Удалить рецепт",
  prescription_delete_text: "Вы уверены, что хотите удалить рецепт?",
  continue_with: (content: string) => `Продолжить с ${content}`,
  available_days: "Свободные дни",
  create_request: "Создать запрос",
  category: "Категория",
  choose: "Выбрать",
  quantity: "Количество",
  write: "Заполнить",
  m_u: "Е/и",
  description: "Описание",
  attach_file: "Прикрепить файл",
  phone_number: "Номер телефона",
  name: "Имя",
  surname: "Фамилия",
  send: "Отправить",
  add_your_information: "Добавьте вашу информацию",
  request_success: "Ваш запрос отправлен!",

  no_such_promo  : "Промокод не найден",
  card_missing : "Бонусная карта отсутствует",
  invalid_card : "Промокод не доступен данной бонусной карте",
  promo_limit_expired : "Достигнут лимит использования промокода",
  card_limit_expired : "Достигнут лимит использования промокода для бонусной карты",
  promo_percent_is_smoller: "Промокод не сработал, есть более выгодная акция",
  does_not_make_sense : "Нет продукта, связанного с промо кодом",
  delevery_does_not_make_sense: "Промокод не сработал, уже есть бесплатная доставка",
  not_valid_time: "Промокод действителен с 12:00 до 17:00.",
  not_valid_promo_limit_expiered: "Количество использования промокода исчерпана.",
  promocode_message_1: "Для использования промокода необходимо ",
  promocode_message_2: "зарегистрироваться",
  promocode_message_3: " в приложении интернет-аптеки Альфа-Фарм.",

  basket_save_success: "Корзина была сохранена",
  order_create_success: "Ваш заказ отправлен!",
  out_of_stock_delete_confirm: "Отмеченый продукта нет в наличии. Пожалуйста, удалите его для оформления заказа. Удалить?",
  contact_success: "Ваше сообщение отправлено!",
  personal_data_success: "Личные данные были изменены!",
  phone_verify_success: "Телефон был изменен!",
  phone_code_send_success: "Код подтверждения отправлен!",
  email_send_success: "Ссылка для подтверждения была отправлена на Эл. адрес!",
  checkout_promo_address_error: "Предоставьте адрес",
  gift_success: "У вас есть подарок",
  gift: "Подарок",
  day_off: "Выходной",
  monday: "Пон.",
  tuesday: "Втр.",
  wednesday: "Ср.",
  thursday: "Чт.",
  friday: "Пт.",
  saturday: "Сбт.",
  sunday: "Вск.",
  my_orders: "Мои заказы",
  item: 'Штука',
  my_requests: "Мои запросы",
  my_companies: "Мои компании",
  cancel_order: 'Вы хотите отменить этот заказ?',
  order_canceled: 'Заказ успешно отменен.',
  basket_at_least_2000: "Стоимость онлайн-заказа должна быть более 2000 AMD.",
  delete_saved_product_basket: 'Вы хотите удалить сохраненную корзину?',
  delete_product: 'Удалить продукт',
  delete_product_from_basket: 'Вы уверены, что хотите удалить этот продукт?',
  delete_basket: 'Удалить корзину',
  delete_all_baskets: 'Вы уверены, что хотите удалить всю корзину?',
  my_registrations: "Записи",
  medical_history: "История болезни",
  special_products: "Специальные продукты",
  special_products_replace_fail: (date: string) => `Заменить товар можно только после ${date}`,
  my_wallet: "Мой бумажник",
  my_addresses: "Мои адреса",
  wrong_password_length: 'Пароль должен содержать не менее 6 символов.',
  addresses: "Адреса",
  package: 'Упаковка',
  log_out: "Выйти",
  log_out_question: 'Вы уверены, что хотите выйти?',
  add_new_address: "+ Добавить новый адрес",
  add_address: "Добавить адрес",
  edit_address: "Редактировать адрес",
  save: "Сохранить",
  save_cart: "Сохранить корзину",
  saved_carts: "Сохраненные корзины",
  saved_basket: "Сохраненные корзины",
  default_address: "Адрес по умолчанию",
  full_name: "Полная имя",
  first_name: "Имя",
  last_name: "Фамилия",
  message: "Сообщение",
  write_a_message: "Написать сообщение",
  promotions: "Специальные предложения",
  address: "Адрес",
  house: "Дом",
  apartment: "Квартира",
  building: "Здание",
  entrance: "Вход",
  floor: "Этаж",
  contact_text: contactText,
  contract_text: contractText,
  exchange_return_text: exchangeReturnText,
  confidentiality_conditions_text: confidentialityConditionsText,
  deciphered_prescription: "Расшифрованная рецептура",
  deciphered: "Расшифрованный",
  edit: "Редактировать",
  remove: "Удалить",
  edit_company: "Редактировать компанию",
  add_company: "Добавить компанию",
  add_new_company: "+ Добавить новую компанию",
  tin: "ИНН",
  billing_address: "Платежный адрес",
  delivery_address: "Тип заказа",
  delivery_method: "Время заказа",
  date_of_order: "Date of order",
  contact_person: "Контактний человек",
  add_other_address: "+ Добавить другой адрес",
  company_name: "Название компании",
  my_account: "Мой аккаунт",
  form: "Форма",
  only_files: "Только файлы",
  only_files_request_text: "Если у вас нет времени, чтобы выполнить запрос, вы можете прикрепить существующие файлы.",
  about_the_project: "О проекте",
  how_we_work: "Как мы работаем",
  career_apply_success: "Ваша заявка успешно принято.",
  the_advantages_of_cooperation: "Преимущества сотрудничества",
  city: "Город",
  region: "Область",
  district: "Район",
  delivery: "Доставка",
  delivery_fee: "Плата за доставку",
  bonus_card: "Бонусная карта",
  bonus_card_empty: "У вас нет истории бонусов",
  mobile_app: "Мобильное приложение",
  about_delivery_text: "Доставка онлайн аптеки «Альфа-Фарм» осуществляется по г. Ереван, обычно в течение 2 часов с момента получения заказа. Доставка в регионах осуществляется путем передачи заказа в ближайшие филиалы Альфа-Фарм, обычно в течение 3 дней, откуда покупатель забирает заказ.",
  about_bonus_card_text: "Бонусная карта Альфа-Фарм дает покупателям возможность аккумулировать бонусные баллы от покупок в аптеках Альфа-Фарм, положить предоплату на свой счет и использовать при покупках в аптеках Альфа-Фарм. Более подробно можно ознакомиться в разделе «Условия Альфа карты».",
  about_mobile_app_text: "Мобильное приложение Альфа-Фарм позволяет иметь быстрый доступ к онлайн аптеке. Ваша бонусная карта будет доступна в приложении и будет всегда с Вами, Вы сможете всего несколькими нажатиями совершать покупки из онлайн аптеки, видеть карту аптек, ознакомиться с товарным ассортиментом и много других полезных функций.",
  about_mobile_app_text_2: "Мобильное приложение можно скачать с Play Market или App Store поискав “Alfa Pharm” или сканировав одну из нижеприведенных QR кодов.",
  about_the_project_text: aboutTheProjectText,
  how_we_work_text: howWeWorkText,
  adventages_text: adventagesText,
  delivery_text: deliveryText,
  for_partners: "Для партнеров",
  invitation_to_cooperate: "Приглашение к сотрудничеству",
  empty_card_list: 'Нет прикрепленных карт',
  partners_account_login: "Вход для партнеров",
  help_for_partners: "Помощь для партнеров",
  follow_us: "Подписывайтесь на нас",
  empty_favorites_list: 'Список избранных пуст',
  empty_carts_list: 'Список карт пуст',
  empty_registrations_list: 'Список регистраций пуст',
  empty_medical_history: 'Список истории болезней пуст',
  buy_bundle_promotion: "Покупайте прилагаемые товары вместе и получайте бонусы.",
  empty_orders_list: 'Список заказов пуст',
  empty_special_products: 'Список специальних продуктов пуст',
  empty_address_list: 'Список адресов пуст',
  empty_prescriptions_list: 'Список рецептов пуст',
  empty_tenders_list: 'Список тендеров пуст',
  yes: 'Да',
  no: 'Нет',
  facebook: "Facebook",
  instagram: "Instagram",
  linked_in: "LinkedIn",
  language: "Язык",
  ineed_app: "ineed приложения",
  change_password: "Изменить пароль",
  personal_data: "Личные данные",
  save_changes: "Сохранить изменения",
  verification: "Подтверждения",
  verification_text: "Пожалуйста, напишите проверочный код",
  ok: "Хорошо",
  send_again: "Отправить еще раз",
  features: "Характеристики",
  additional_sales: "Дополнительные продажи",
  get: "получите",
  off: "скидку",
  discount: "Скидка",
  and: "и",
  i_bonus: "iBonus",
  bonus: "Бонус",
  invited: "Приглашен",
  days: "День",
  go_to_checkout: "Перейти к оформлению заказа",
  buy: "Купить",
  add_to_cart: "Добавить в корзину",
  add_to_cart_short: "Добавить",
  average_price_of_previous_month: "Средняя цена предыдущего месяца",
  lists: "Списки",
  active: "Активные",
  completed: "Завершенные",
  request_forms: "Форма запроса",
  request_files: "Файл(ы) запроса",
  finished: "Законченный",
  delivered: "Законченный",
  canceled: "Отменен",
  pending: "В ожидании",
  success: "Успешный",
  failed: 'Не удачно',
  attached_to_carrier: 'В ожидании',
  confirmed_by_branch_admin: 'В ожидании',
  not_completed: 'В ожидании',
  ready_to_start: 'Собранный',
  started: 'В процессе',
  success_book: "Спасибо! Ваш запрос на регистрацию был одобрен. Вы можете следить за статусом вашего приëма в разделе «Мои приëмы» на вашей Личной странице.",
  best_selling: "Самые продаваемые",
  new_products: "Новые продукты",
  alphabetical_a_z: "По алфавиту А - Я",
  alphabetical_z_a: "По алфавиту Я - А",
  price_low_to_high: "Цена: От низкой к высокой",
  price_high_to_low: "Цена: От высокой к низкой",
  discount_low_to_high: "Скидка: От низкой к высокой",
  discount_high_to_low: "Скидка: От высокой к низкой",
  buy_again: "Купить снова",
  price: "Цена",
  other_offers: "Разное",
  settings: "Настройки",
  brands: "Производители",
  brand: "Производитель",
  producers: "Страны",
  producer: "Страна",
  active_ingredients: "Активные ингредиенты",
  active_ingredient: "Активный ингредиент",
  min: "Минимум",
  max: "Максимум",
  clear_filters: "Очистить Фильтры",
  clear_all: "Очистить все",
  as_soon_as_possible: "Как можно быстрее",
  date: "Дата",
  created_date: "Дата создания",
  end_date: "Конечная дата",
  sender: "Отправитель",
  add_new_list: "+ Добавить новый список",
  payer: "Плательщик",
  clear_basket: 'Очистить корзину',
  no_search_result: 'Нет результатов поиска',
  pay: "Оплатить",
  add_list: "Добавить список",
  edit_list: "Редактировать список",
  i: "Я",
  edit_invited_list: "Управлять списком приглашенных",
  leave_wish_list: "Выйти из списка",
  delete: "Удалить",
  no_options: "Нет вариантов",
  no_companies: "Нет компаний",
  new: "+ Новый",
  NEW: "NEW",
  owner: "Владелец",
  no_lists: "Нет списков",
  choose_all_attributes: "Выберите все атрибуты",
  requested_products: "Запрашиваемый продукт(ы)",
  filter_for_users: "Фильтр пользователей",
  my: "Моя",
  or: "или",
  copy: "Скопировать",
  copied_to_clipboard: "Скопировано в буфер обмена",
  copied_promocode_to_clipboard: "Промокод скопирован успешно",
  url: "URL",
  confirm_description: "Вам необходимо подтвердить это действие",
  confirm: "Подтвердить",
  choose_address: "Выбрать адрес",
  choose_pharmacy: "Выберите аптеку",
  choose_time: "Выбрать время",
  asap: "Как можно скорее",
  choose_date: "Выберите дату",
  user_request_ask: "попросит добавить следующий элемент в этот список",
  apply_online: "Подать Заявку Онлайн",
  prescription: "Рецепт",
  prescriptions: "Рецептури",
  add_prescription: "Создать рецептуру",
  medical_institution: "Медицинское учреждение",
  upload_image: "Загрузить фото",
  upload_prescription_image: "Загрузить рецепт",
  upload: "Загрузить",
  cancel: "Отменить",
  total: "Итого",
  subtotal: "Общая сумма",
  promo_discount: "Promo скидка",
  points_: "балл",
  Points:"Баллы",
  points: "Баллы",
  pointss: "балов",
  point: "Балл",
  user_points: "Баллов",
  bonus_count: 'Кол. бонусов',
  checkout: "Оформить заказ",
  type: "Тип",
  empty_price_list: 'Список цен пуст',
  empty_saved_basket_list: 'Список предпочтительных корзин пуст.',
  empty_doctors_list: 'Список врачей пуст',
  empty_blogs_list: 'Лист блогов пуст.',
  pricing: "Платеж",
  additionally: "Дополнительно",
  comment: "Комментарий",
  address_comment: "Адресный комментарий",
  retail_sale: "Розничная продажа",
  wholesale_sale: "Оптовая продажа",
  wholesale_sale_price_list: "Прайс-лист",
  wholesale_sale_service: "Услуги",
  wholesale_sale_big_sale: "Оптовые акции",
  wholesale_sale_online_sale: "Онлайн продажа",
  online_sale_new_website: "Онлайн продажа (Новый веб-сайт)",
  wholesale_promotions: "Оптовые акции",
  child_offers: "Детские",
  seasonal_offers: "Сезонные Предложения",
  cosmetics_offers: "Косметика",
  orthopedic_products : "Ортопедические изделия и компрессионный трикотаж",
  medicines_offers: "Медикаменты",
  useful_links: "Полезные ссылки",
  about_company: "О компании",
  information: "Информация",
  contact: "Связь",
  last_search_results: "История Поиска",
  products: "Товары",
  product: "Товар",
  see_more: "Показать больше",
  pickup: "Забрать из аптеки",
  sale: "Распродажа",
  sort_by: "Сортировать по",
  show_all: "Показать все",
  search: "Поиск",
  search_results: "Результаты поиска",
  stuff: "Группа работников",
  popular_categories: "Популярные категории",
  cash: "Наличные",
  i_pay: "IPay",
  post_terminal: "POS-терминал",
  idram: "Idram",
  talcell: "Telcell",
  card: "Карта",
  answer_text: "Вы ответили",
  bank_transfer: "Банковский перевод",
  delivery_date: "Дата доставки",
  footer_text: "«Альфа Фарм» - крупнейшая сеть аптек, расположенных во многих регионах Армении.",
  order_a_call: "Заказать звонок",
  invite: "Пригласить",
  invite_your_friend: "Пригласите вашего друга",
  copy_and_share: "Скопируйте указанную ссылку и поделитесь ею с друзьями.",
  earn_bonus_points: "Зарабатывайте бонусные баллы, приглашая друзей в мобильное приложение Alpha Farm.",
  use_the_link: "Воспользуйтесь ссылкой",
  pickup_date: "Дата заезда",
  done: "Готово",
  spin: "Крутить",
  order_number: "Номер заказа",
  accumulated_points:'Накопленные баллы',
  used_points:'Использованные баллы',
  balance:'Баланс',
  status: "Статус",
  repeat: "Повторить",
  payment_method: "Способ оплаты",
  product_deleted_warning: "Продукт был удален!",
  all_products: "Все продукты",
  are_you_sure: "Вы уверены?",
  are_you_sure_cancel_order: "Вы уверены, что хотите отменить заказ?",
  mark_as_read: "Отметить как прочитанное",
  written: "Написано",
  confirm_new_password: "Подтвердите новый пароль",
  confirm_password: "Подтвердите пароль",
  current_password: "Действующий пароль",
  new_password: "Новый пароль",
  choose_password: "Выберите пароль",
  similar: "Единообразный",
  similar_products: "Похожие продукты",
  sign_up_confirm: <>Я согласен с <a target="_blank" role="noreferrer" href={ROUTES.EXCHANGE_RETURN}>тезоми</a> и <a target="_blank" role="noreferrer" href={ROUTES.CONFIDENTIALITY_CONDITIONS}>условиями</a></>,
  reason: "Причина",
  show_more: "Показать больше",
  read_more: "Читать далее",
  promo_code: "Введите код",
  promoCode: "Промо код",
  thePromoCode: "Промо код",
  apply: "Подать заявку",
  special_offers: "Витамины / Биоактивные добавки",
  suggested_products: "Рекомендуемые продукты",
  additional_sale_label: (fromCount: number) => `Купите ${fromCount} и больше,`,
  checkout_i_bonus_can_use: (bonus: number, points: number): string => `Вы можете использовать ${bonus} ${Settings.translations.i_bonus} из вашей ${points}`,
  receiving_bonus: "Полученный iBonus",
  use_bonus_points: "Использовать бонусные баллы",
  used_bonus: "Использованный бонус",
  used_bonus_: "Использованный бонусный",
  gained_bonus: "Полученный бонус",
  gained_bonus_: "Накопленный бонусный",
  no_products: "Нет товаров",
  no_addresses: "Нет адресов",
  no_orders: "Нет заказов",
  no_requests: "Нет запросов",
  no_notifications: "Нет Уведомлений",
  categories: "Категории",
  child_category: "Категория",
  pharmacies: "Аптеки",
  online_pharmacy: "Онлайн аптека",
  in_online_pharmacy: "в приложении интернет-аптеки",
  special_offer: "Special offers",
  online_sales: "Онлайн продажи",
  clinic: "Клиника",
  doctors: "Врачи",
  laboratory: "Лаборатория",
  price_list: "Цены",
  blog: "Блог",
  news: "Новости",
  tenders: "Тендеры",
  order_a_call_success: "Ваш запрос успешно отправлен. Наш оператор свяжется с вами в ближайшее время.",
  order_success: "Спасибо, ваш заказ подтвержден. Ознакомиться с деталями заказа можно в разделе истории заказов.",
  order_fail: "Ваш платеж не прошел։",
  guest_order_success: 'Спасибо, ваш заказ подтвержден. Зарегистрируйтесь в системе Альфа-Фарм и накапливайте бонусы, делая заказы в онлайн-аптеке.',
  prescription_success: "Спасибо! Запрос вашего рецепта подтвержден. Рецепт будет рассмотрен, и мы отправим вам список лекарств в кратчайшие сроки.",
  appointment_success: "Спасибо ваша запись принята. Проследить статус можете в разделе Мои регистрации.",
  availability_at_the_nearest_pharmacy: "Наличие в ближайшей аптеке",
  good_morning: "Доброе утро",
  out_of_stock: "Нет на складе",
  of_stock: "На складе",
  good_afternoon: "Добрый день",
  home: "Домашняя страница",
  home_app: "Главная",
  profile: "Профиль",
  profile_page: "Персональные данные",
  recipes: "Рецепты",
  good_evening: "Добрый вечер",
  add_special_product: "Добавить специальный продукт",
  show_less: "Показать меньше",
  get_my_order: "Найти мой заказ",
  treatment: "Лечение",
  get_my_order_text: "Пожалуйста, напишите код подтверждения, отправленный на",
  code: "Код",
  notifications: "Уведомления",
  insttallApp: "Скачать приложение",
  installationBonuses: "Зарегистрируйтесь и получите 5000 iBonus",
  install: "Утановить",
  success_partner: 'Партнер успешно добавлен',
  email_or_phone: "Эл. адрес или номер телефона",
  send_request: "Послать запрос",
  message_sent: 'Ваше сообщение было успешно отправлено.',
  privacy_policy: "Политику конфиденциальности",
  privacy_policy_text : PrivacyPolicyText,
  terms_of_use: "Условия использования",
  businnes_description: "В ineed, мы стремимся работать с нашими клиентами для достижения результатов, необходимых для развития их бизнеса. Отправьте нам запрос и станьте нашим партнером",
  wrong_email: 'Неправильный эл. адрес',
  wrong_password: 'Неправильный пароль',
  passwords_do_not_match: 'Пароли не совпадают',
  draft: 'Черновик',
  please_check_correctness_of_email_or_phone_number: 'Пожалуйста, проверьте правильность адреса электронной почты или номера телефона',
  gender: 'Пол',
  date_of_birth: 'Дата рождения',
  pay_with_credit_card: "Оплатить кредитной картой",
  male: 'Мужской',
  female: 'Женский',
  not_filled: 'Не заполненный',
  open: 'Открыто',
  closed: 'Закрыто',
  about_us_1:'Современный логистический центр компании занимает площадь 3600 квадратных метров, оснащен новейшим поточно-технологическим оборудованием, отвечающим самым строгим требованиям по хранению, обработке и отпуску лекарственных средств. Высокая пропускная способность логистического центра позволяет своевременно доставлять проданный нами ассортимент товаров в более чем 1000 аптек и медицинских учреждений.',
  about_us_2:'Сеть аптек «Альфа Фарм» насчитывает более 170 аптек и является самой крупной географически разветвленной сетью в стране. Сетевые аптеки работают в Ереване, Гюмри, Ванадзоре, Степанаване, Вайке, Сане, Мартуни, Гаваре, Абовяне, Раздане, Бюрегаване, Чаренцаване, Аштараке, Армавире, Арарате, Капане.',
  about_us_22:'Круглосуточная служба доставки Альфа-Фарм работает с 2018 года. Эта первая в Армении круглосуточная онлайн-аптека. Служба доставки в настоящее время работает только в городе Ереван. А клиенты, проживающие в регионах, могут сделать заказ на сайте или с помощью мобильного приложения «Альфа-Фарм» и получить заказ в ближайшей аптеке «Альфа-Фарм». Цены, указанные на продукцию на сайте и в мобильном приложении «Альфа-Фарм», действуют только при онлайн заказе и могут отличаться от цен в аптечной сети.',
  about_us_3:'В штате нашей компании более 800 сотрудников, в том числе высококвалифицированные фармацевты, специалисты по логистике, менеджеры по продажам, управленческий персонал, получающий непрерывное образование в учебном центре компании. Цель нашей повседневной работы - поддерживать эффективную борьбу с различными заболеваниями, помогать мамам правильно кормить своих детей, предлагать качественную косметику и оптику.',
  bl:"ruserenBl",
  page_not_found:"Страница не найдена",
  apps:"Приложение",
  get_it: "ПОЛУЧАЙ",
  the_first_orders: "использовав для первых 3 заказов",
  banner_bottom_text: "Воспользоваться промокодом можно, зарегистрировавшись на сайте alfapharm.am или в мобильном приложении AlfaPharm.",

  notification_texts: {
    request_failed: {
      title: "Ваш запрос не выполнен",
      body: "Извините, но мы не смогли найти нужный Вам товар",
    },
    request_succeeded: {
      title: "Ваш запрос выполнен",
      body: "Нажмите, чтобы увидеть детали о найденном товаре",
    },
    order_canceled: {
      title: "Ваш заказ отменен",
      body: "Нажмите, чтобы увидеть детали",
    },
    order_finished: {
      title: "Ваш заказ завершен",
      body: "Нажмите, чтобы увидеть детали и получить бонусы",
    },

    order_idram_failed: {
      title: "Не удалось выполнить платеж",
    },

    wish_list_delete: {
      title: "Список покупок удален",
      body: "К сожалению, один из ваших списков покупок был удален его создателем",
    },
    wish_list_leave: {
      title: "Участник вышел из списка желаний",
      body: "К сожалению, участник покинул ваш список желаний",
    },
    wish_list_new_product: {
      title: "Новый продукт",
      body: "Новый продукт был добавлен в список покупок",
    },
    wish_list_remove_product: {
      title: "Продукт удален",
      body: "Продукт был удален из списка покупок",
    },
    wish_list_product_request: {
      title: "Добавление продукта",
      body: "Участник хочет добавить новый продукт в список покупок",
    },
    wish_list_unapprove: {
      title: "Отклонение продукта",
      body: "Запрашиваемый продукт был отклонен в списке покупок",
    },
    wish_list_approve: {
      title: "Одобрение продукта",
      body: "Запрашиваемый продукт был одобрен в списке покупок",
    },
    wish_list_kick: {
      title: "Членство списка покупок",
      body: "К сожалению, вы были удалены из списка желаний",
    },
    wish_list_new_member: {
      title: "Членство списка покупок",
      body: "Новый участник присоединился к списку покупок",
    },
  },
  items_per_page: "Элементы на странице",
  bonus_history: "Истоия бонусов",
  bonus_history_online: "Истоия бонусов | онлайн",
  bonus_history_pharmacy: "Истоия бонусов | Аптека",

};
